<template>
  <errorContainer :error="erreur">
    <div class="animated fadeIn">
      <!-- <pre>{{ project }}</pre> -->
      <b-row class="container-layout px-0">
        <b-col md="12">
          <div class="card card-border-blue-light">
            <b-form @submit.prevent="submitForm">
              <div v-if="errors.length">
                <b>{{ FormMSG(52, 'Please correct the following error(s)') }}:</b>
                <ul>
                  <li v-for="(error, i) in errors" :key="i">{{ error }}</li>
                </ul>
              </div>
              <b-row>
                <b-col :sm="!isModal ? 9 : 12">
                  <b-form-group :label="FormMSG(125, 'Type')" label-for="projectType" label-cols="3">
                    <b-form-select
                      id="projectType"
                      v-model="project.projectType"
                      :disabled="!enableProjectTypeChoice || isFilmSingle"
                      :options="mapTgsProjectType"
                    ></b-form-select>
                  </b-form-group>
                  <b-row v-if="project.projectType == 0 || project.projectType == 3 || project.projectType == 4">
                    <b-col lg="12">
                      <b-form-group :label="FormMSG(504, 'Project reference')" label-for="projectReference" :label-cols="3" :horizontal="true">
                        <b-form-input id="projectReference" v-model="project.reference" type="text"></b-form-input>
                      </b-form-group>
                      <b-form-group :label="FormMSG(1, 'Title')" label-for="titre" :label-cols="3" :horizontal="true">
                        <b-form-input id="titre" v-model="project.titre" type="text"></b-form-input>
                      </b-form-group>
                      <b-row v-if="$screen.width > 567">
                        <b-col lg="3" :class="`${$screen.width < 768 ? '' : 'mt-3'}`">
                          <p class="fw-700 fs-14 text-color-rhapsody-in-blue">{{ labelLegalEntity }}</p>
                        </b-col>
                        <b-col lg="9">
                          <supplier-selector
                            ref="projectAdmin"
                            label=""
                            :show-map="false"
                            :title="`${!isSupplierUpdate ? FormMSG(1205, 'Add entity details') : FormMSG(1206, 'Update entity details')}`"
                            :placeholder="FormMSG(1132, 'Enter your legal entity name')"
                            :addlabel="FormMSG(5446, 'Add')"
                            :update-label="FormMSG(13, 'Update')"
                            type="projectAdmin"
                            :supplier-id="selectedSupplier"
                            :from-project-config="true"
                            use-new-design
                            version="1.0"
                            @change="handleAdminOwnerChange"
                            @supplier:unselected="onAdminOwnerUnselected"
                          />
                        </b-col>
                      </b-row>
                      <fieldset v-if="$screen.width <= 567" class="card-inside">
                        <legend class="card-inside">{{ labelLegalEntity }}</legend>
                        <b-row>
                          <b-col>
                            <supplier-selector
                              ref="projectAdmin"
                              label=""
                              :show-map="false"
                              :title="`${!isSupplierUpdate ? FormMSG(1205, 'Add entity details') : FormMSG(1206, 'Update entity details')}`"
                              :placeholder="FormMSG(1132, 'Enter your legal entity name')"
                              :addlabel="FormMSG(5446, 'Add')"
                              :update-label="FormMSG(13, 'Update')"
                              type="projectAdmin"
                              :from-project-config="true"
                              :supplier-id="selectedSupplier"
                              use-new-design
                              version="1.0"
                              @change="handleAdminOwnerChange"
                              @supplier:unselected="onAdminOwnerUnselected"
                            />
                          </b-col>
                        </b-row>
                      </fieldset>
                      <b-form-group :label="FormMSG(1134, 'Use legal entity data for crew invoicing')" label-cols="3">
                        <b-form-checkbox
                          v-if="project.projectType !== 3 && project.projectType !== 4"
                          id="useFCI"
                          v-model="project.useForCrewInvoice"
                          size="lg"
                          style="margin-top: 4px"
                        />
                      </b-form-group>
                      <b-form-group
                        v-if="project.useForCrewInvoice == false && project.projectType !== 3 && project.projectType !== 4"
                        :label="FormMSG(1133, 'Invoice details for crew')"
                        label-for="invoiceDetails"
                        label-cols="3"
                      >
                        <b-form-textarea
                          id="invoiceDetails"
                          v-model="project.invoiceDetails"
                          :placeholder="FormMSG(22, 'Enter invoice details here...')"
                          :no-resize="true"
                          :state="project.invoiceDetails.length < 4000"
                          rows="6"
                        ></b-form-textarea>
                      </b-form-group>
                      <b-form-group
                        v-if="project.projectType == 0 || project.projectType == 3 || project.projectType == 4"
                        :label="FormMSG(2, 'Production')"
                        label-for="production"
                        :label-cols="3"
                        :horizontal="true"
                      >
                        <b-form-input id="production" v-model="project.production" type="text"></b-form-input>
                      </b-form-group>
                      <b-form-group
                        v-if="project.projectType == 0"
                        :label="FormMSG(20, 'Co-production')"
                        label-for="coProducers"
                        :label-cols="3"
                        :horizontal="true"
                      >
                        <b-form-input id="coProducers" v-model="project.coProducers" type="text"></b-form-input>
                      </b-form-group>
                      <b-form-group
                        v-if="project.projectType == 0 || project.projectType == 3 || project.projectType == 4"
                        :label="FormMSG(3156, 'Main production country')"
                        label-for="production"
                        :label-cols="3"
                        :horizontal="true"
                      >
                        <CountrySelector
                          v-model="project.mainProductionCountry"
                          for-carbon-clap
                          custom-id="main_production_country"
                          :country-selected="project.mainProductionCountry"
                          @change="(country) => handleMainCountryChange(country, 'mainProductionCountry')"
                        />
                      </b-form-group>
                      <b-form-group
                        v-if="project.projectType == 0"
                        :label="FormMSG(3155, 'Co-production countries')"
                        label-for="coProducers"
                        :label-cols="3"
                        :horizontal="true"
                      >
                        <MultipleCountrySelector
                          v-model="project.coProductionCountries"
                          multiple
                          for-carbon-clap
                          custom-id="main_production_country"
                          :country-selected="project.coProductionCountries"
                          @change="(country) => handleCountryChange(country, 'coProductionCountries')"
                        />
                      </b-form-group>
                      <b-form-group :label="FormMSG(888, 'Production type')" label-for="optionForType" :label-cols="3">
                        <b-form-select id="optionForType" v-model="project.productionType" :options="optionForType"></b-form-select>
                      </b-form-group>
                      <b-form-group :label="FormMSG(81, 'Production method')" label-for="optionForMethod" :label-cols="3">
                        <v-select
                          v-model="project.productionMethod"
                          :options="optionForMethod"
                          label="text"
                          :reduce="(option) => option.value"
                          :multiple="true"
                        ></v-select>
                      </b-form-group>
                      <b-form-group :label="FormMSG(82, 'Main broadcast mode')" label-for="optionForBroadcastMode" :label-cols="3">
                        <b-form-select id="optionForBroadcastMode" v-model="project.mainBroadcastMode" :options="optionForBroadcastMode"></b-form-select>
                      </b-form-group>

                      <b-row>
                        <b-col :cols="6">
                          <b-form-group :label="FormMSG(889, 'Film length/ avg episode length')" label-for="optionForType" :label-cols="6">
                            <b-input-group class="ml-2">
                              <b-form-input v-model="project.filmLength" type="number" :placeholder="FormMSG(890, 'minutes')" />
                              <b-input-group-append>
                                <b-button disabled class="littleBorderRad"> min </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                        <b-col :cols="4">
                          <b-form-group
                            v-if="project.productionType >= 4 && project.productionType <= 10"
                            :label="FormMSG(891, 'Total')"
                            label-for="optionForType"
                            :label-cols="2"
                          >
                            <b-input-group>
                              <b-form-input v-model="project.numEpisode" type="number" />
                              <b-input-group-append>
                                <b-button disabled class="littleBorderRad"> {{ FormMSG(892, 'episodes') }} </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-form-group :label="FormMSG(895, 'Shooting format')" label-for="optionForFormat" :label-cols="3">
                        <b-form-select id="optionForFormat" v-model="project.shootingFormat" :options="optionForFormat"></b-form-select>
                      </b-form-group>
                      <b-form-group v-if="project.projectType == 0" :label="FormMSG(3, 'Director')" label-for="realisateur" :label-cols="3" :horizontal="true">
                        <b-form-input id="realisateur" v-model="project.realisateur" type="text"></b-form-input>
                      </b-form-group>
                      <b-form-group v-if="project.projectType == 0" :label="FormMSG(21, 'Song and Music')" label-for="music" :label-cols="3" :horizontal="true">
                        <b-form-input id="music" v-model="project.songMusic" type="text"></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row v-if="project.projectType === 1">
                    <b-col lg="12">
                      <b-form-group :label="FormMSG(505, 'Project reference')" label-for="projectReference" :label-cols="3" :horizontal="true">
                        <b-form-input id="projectReference" v-model="project.reference" type="text"></b-form-input>
                      </b-form-group>
                      <b-form-group :label="FormMSG(126, 'Office')" label-for="titre" :label-cols="3" :horizontal="true">
                        <b-form-input id="titre" v-model="project.titre" type="text"></b-form-input>
                      </b-form-group>
                      <b-form-group :label="FormMSG(128, 'Legal entity')" label-for="production" :label-cols="3" :horizontal="true">
                        <b-form-input id="production" v-model="project.production" type="text"></b-form-input>
                      </b-form-group>
                      <b-form-group :label="FormMSG(129, 'CEO')" label-for="realisateur" :label-cols="3" :horizontal="true">
                        <b-form-input id="realisateur" v-model="project.realisateur" type="text"></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row v-if="project.projectType == 2">
                    <b-col lg="12">
                      <b-form-group :label="FormMSG(506, 'Project reference')" label-for="projectReference" :label-cols="3" :horizontal="true">
                        <b-form-input id="projectReference" v-model="project.reference" type="text"></b-form-input>
                      </b-form-group>
                      <b-form-group :label="FormMSG(127, 'Agency')" label-for="titre" :label-cols="3" :horizontal="true">
                        <b-form-input id="titre" v-model="project.titre" type="text"></b-form-input>
                      </b-form-group>
                      <b-form-group :label="FormMSG(128, 'Legal entity')" label-for="production" :label-cols="3" :horizontal="true">
                        <b-form-input id="production" v-model="project.production" type="text"></b-form-input>
                      </b-form-group>
                      <b-form-group :label="FormMSG(129, 'CEO')" label-for="realisateur" :label-cols="3" :horizontal="true">
                        <b-form-input id="realisateur" v-model="project.realisateur" type="text"></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-form-group :label="FormMSG(80, 'Langue')" label-for="optionsForLanguages" :label-cols="3">
                    <b-form-select id="optionsForLanguages" v-model="project.language" :options="optionsForLanguages"></b-form-select>
                  </b-form-group>
                  <b-form-group :label="FormMSG(801, 'Regional Setting')" label-for="regionalSettingOptions" :label-cols="3">
                    <b-form-select id="regionalSettingOptions" v-model="project.regionalSetting" :options="regionalSettingOptions"></b-form-select>
                  </b-form-group>
                  <b-form-group :label="FormMSG(4, 'Time zone')" label-for="timeZone" :label-cols="3" :horizontal="true">
                    <b-form-input id="timeZone" v-model="project.timeZone" type="text"></b-form-input>
                  </b-form-group>
                  <b-form-group :label="FormMSG(5, 'Currency')" label-for="currency" label-cols="3">
                    <b-form-select id="currency" v-model="project.currency" :disabled="!mapCurrencies.length" :options="mapCurrencies"></b-form-select>
                  </b-form-group>
                  <b-form-group :label="FormMSG(6, 'Distance unit')" label-for="distanceUnit" label-cols="3">
                    <b-form-select
                      id="distanceUnit"
                      v-model="project.distanceUnit"
                      :disabled="!mapDistacneUnits.length"
                      :options="mapDistacneUnits"
                    ></b-form-select>
                  </b-form-group>
                  <b-row v-if="!isFilmSingle" class="mb-3">
                    <b-col cols="3" class="fs-14 text-color-rhapsody-in-blue">
                      {{ FormMSG(238, 'Analytic periods') }}
                    </b-col>
                    <b-col cols="5">
                      <b-form-group v-slot="{ ariaDescribedby }">
                        <b-form-radio-group
                          id="itterationAnalytic"
                          v-model="itterationAnalyticSelected"
                          :options="itterationAnalyticOptions"
                          :aria-describedby="ariaDescribedby"
                          name="radio-inline"
                          @change="handleChangeItterationAnalytic"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col v-if="itterationAnalyticSelected !== 1" cols="4">
                      <b-form-select id="analyticPeriods" v-model="project.analyticPeriodType" :options="analyticPeriodOptions" />
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col :cols="6">
                      <div v-if="project.analyticPeriodType !== 2">
                        <b-form-group
                          v-if="project.projectType !== 3 && project.projectType !== 4"
                          :label="FormMSG(48, 'Start date')"
                          label-for="startDate"
                          label-cols="6"
                        >
                          <!-- <b-form-input
														class="ml-2"
														:value="project.startDate && project.startDate.split('T')[0]"
														@input="updateStartDate"
														type="date"
														id="startDate"
													></b-form-input> -->
                          <v-date-picker v-model="project.startDate" :locale="lang" :masks="masks" :attributes="attrs">
                            <template #default="{ inputValue, togglePopover }">
                              <b-input-group class="ml-2">
                                <b-form-input :value="inputValue" readonly @click="togglePopover()" @keydown.enter.prevent />
                                <b-input-group-append>
                                  <b-input-group-text class="cursor-pointer" @click="togglePopover()">
                                    <component :is="getLucideIcon('Calendar')" color="#007A77" :size="16" />
                                  </b-input-group-text>
                                </b-input-group-append>
                              </b-input-group>
                            </template>
                          </v-date-picker>
                        </b-form-group>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col :cols="6">
                      <div>
                        <b-form-group
                          v-if="!isFilmSingle && (project.analyticPeriodType === 1 || project.analyticPeriodType === 2 || project.analyticPeriodType === 4)"
                          :label="FormMSG(410, 'Shooting start date')"
                          label-for="startDateShooting"
                          label-cols="6"
                        >
                          <v-date-picker
                            v-model="project.shootingStartDate"
                            :available-dates="{
                              start: new Date(project.startDate),
                              end: new Date(project.endDate)
                            }"
                            :locale="lang"
                            :masks="masks"
                          >
                            <template #default="{ inputValue, togglePopover }">
                              <b-input-group class="ml-2">
                                <b-form-input :value="inputValue" readonly @click="togglePopover()" @keydown.enter.prevent />
                                <b-input-group-append>
                                  <b-input-group-text class="cursor-pointer" @click="togglePopover()">
                                    <component :is="getLucideIcon('Calendar')" color="#007A77" :size="16" />
                                  </b-input-group-text>
                                </b-input-group-append>
                              </b-input-group>
                            </template>
                          </v-date-picker>
                        </b-form-group>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row v-if="!isFilmSingle && (project.analyticPeriodType === 2 || project.analyticPeriodType === 3 || project.analyticPeriodType === 4)">
                    <b-col :cols="6">
                      <div>
                        <b-form-group :label="FormMSG(411, 'Wrap start date')" label-for="startDateWrap" label-cols="6">
                          <v-date-picker
                            v-model="project.wrapStartDate"
                            :available-dates="{
                              start: new Date(project.startDate),
                              end: new Date(project.endDate)
                            }"
                            :locale="lang"
                            :masks="masks"
                          >
                            <template #default="{ inputValue, togglePopover }">
                              <b-input-group class="ml-2">
                                <b-form-input :value="inputValue" readonly @click="togglePopover()" @keydown.enter.prevent />
                                <b-input-group-append>
                                  <b-input-group-text class="cursor-pointer" @click="togglePopover()">
                                    <component :is="getLucideIcon('Calendar')" color="#007A77" :size="16" />
                                  </b-input-group-text>
                                </b-input-group-append>
                              </b-input-group>
                            </template>
                          </v-date-picker>
                        </b-form-group>
                      </div>
                    </b-col>
                    <b-col :cols="4">
                      <b-form-group :label="FormMSG(900, 'Total filming')" :label-cols="6">
                        <b-input-group>
                          <b-form-input v-model="diffDatesFilm" disabled />
                          <b-input-group-append>
                            <b-button disabled class="littleBorderRad"> {{ FormMSG(897, 'days') }} </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col :cols="6">
                      <b-form-group
                        v-if="project.projectType !== 3 && project.projectType !== 4"
                        :label="FormMSG(49, 'End date')"
                        label-for="endDate"
                        label-cols="6"
                      >
                        <!-- <b-form-input
													class="ml-2"
													:value="project.endDate && project.endDate.split('T')[0]"
													@input="updateEndDate"
													type="date"
													id="endDate"
												></b-form-input> -->
                        <v-date-picker v-model="project.endDate" :locale="lang" :masks="masks" :attributes="attrs">
                          <template #default="{ inputValue, togglePopover }">
                            <b-input-group class="ml-2">
                              <b-form-input :value="inputValue" readonly @click="togglePopover()" @keydown.enter.prevent />
                              <b-input-group-append>
                                <b-input-group-text class="cursor-pointer" @click="togglePopover()">
                                  <component :is="getLucideIcon('Calendar')" color="#007A77" :size="16" />
                                </b-input-group-text>
                              </b-input-group-append>
                            </b-input-group>
                          </template>
                        </v-date-picker>
                      </b-form-group>
                    </b-col>
                    <b-col :cols="4">
                      <b-form-group :label="FormMSG(896, 'Total production')" :label-cols="6">
                        <b-input-group>
                          <b-form-input v-model="diffDates" disabled />
                          <b-input-group-append>
                            <b-button disabled class="littleBorderRad"> {{ FormMSG(897, 'days') }} </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-form-group :label="FormMSG(51, 'Certification')" label-for="greenReporting" label-cols="3">
                    <b-form-select id="greenReporting" v-model="project.greenReporting" :options="mapGreenReporting" @change="handleGreenModel"></b-form-select>
                  </b-form-group>
                  <!-- v-if="project.projectType !== 3 && project.projectType !== 4 && project.useReporting" -->
                  <b-form-group v-if="isDev" :label="FormMSG(15, 'Carbon calculator')" label-for="carbonCalculator" label-cols="3">
                    <b-form-select id="carbonCalculator" v-model="project.carbonModel" :options="mapCarbonModels" />
                    <!-- :disabled="disableCarbonModel" -->
                  </b-form-group>
                  <b-form-group
                    v-if="project.projectType !== 3 && project.projectType !== 4 && project.useReporting && project.greenReporting === 3"
                    :label="FormMSG(3151, 'Carbon clap token')"
                    label-for="ccToken"
                    :label-cols="3"
                  >
                    <b-form-textarea
                      id="greenReporting"
                      v-model="project.ccPersonalAccessToken"
                      :placeholder="FormMSG(4871, 'Enter carbon clap token')"
                      rows="3"
                    />
                  </b-form-group>
                  <b-row>
                    <b-col>
                      <b-form-checkbox id="hasCncEcoRequirements" v-model="project.hasCncEcoRequirements" size="lg" class="pj-cb pb-1">
                        {{ FormMSG(3152, 'Project subject to CNC green regulation') }}
                      </b-form-checkbox>
                    </b-col>
                  </b-row>
                  <b-row v-if="project.hasCncEcoRequirements" class="pt-2">
                    <b-col cols="12">
                      <b-form-group :label="FormMSG(3153, 'Projected data audit date')" label-for="startDateWrap" label-cols="3">
                        <v-date-picker v-model="project.projectedDataAuditDate" :locale="lang" :masks="masks">
                          <template #default="{ inputValue, togglePopover }">
                            <b-input-group>
                              <b-form-input :value="inputValue" readonly @click="togglePopover()" @keydown.enter.prevent />
                              <b-input-group-append>
                                <b-input-group-text class="cursor-pointer" @click="togglePopover()">
                                  <component :is="getLucideIcon('Calendar')" color="#007A77" :size="16" />
                                </b-input-group-text>
                              </b-input-group-append>
                            </b-input-group>
                          </template>
                        </v-date-picker>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row v-if="project.hasCncEcoRequirements">
                    <b-col cols="12">
                      <b-form-group :label="FormMSG(3154, 'Final data audit date')" label-for="startDateWrap" label-cols="3">
                        <v-date-picker v-model="project.finalDataAuditDate" :locale="lang" :masks="masks">
                          <template #default="{ inputValue, togglePopover }">
                            <b-input-group>
                              <b-form-input :value="inputValue" readonly @click="togglePopover()" @keydown.enter.prevent />
                              <b-input-group-append>
                                <b-input-group-text class="cursor-pointer" @click="togglePopover()">
                                  <component :is="getLucideIcon('Calendar')" color="#007A77" :size="16" />
                                </b-input-group-text>
                              </b-input-group-append>
                            </b-input-group>
                          </template>
                        </v-date-picker>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="9">
                      <b-form-group :label="FormMSG(507, 'Payroll interface')" label-for="payrollInterface" label-cols="4">
                        <b-form-select id="payrollInterface" v-model="project.payrollInterface" :options="mapPayrollInterface" />
                      </b-form-group>
                    </b-col>
                    <b-col v-if="project.payrollInterface > 0" id="payrollCode" lg="3" class="select_items_filter_wrapper">
                      <payroll-code style-type="button" />
                    </b-col>
                    <b-tooltip v-if="project.payrollInterface > 0" target="payrollCode" triggers="hover">
                      {{ FormMSG(562, 'Manage payroll codes...') }}
                    </b-tooltip>
                  </b-row>
                  <b-row v-if="displayLargeAccount">
                    <b-col lg="12">
                      <b-form-group class="form-row align-items-center" :label="FormMSG(1234, 'Large account')" label-for="largeAccount" :label-cols="3">
                        <b-form-checkbox id="largeAccount" v-model="project.largeAccount" size="lg" :disabled="disableLargeAccount"></b-form-checkbox>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row v-if="displayLargeAccount && project.largeAccount">
                    <b-col lg="12">
                      <b-form-group class="form-row align-items-center" :label="FormMSG(1135, 'Payment status')" label-for="largeAccountPaid" :label-cols="3">
                        <b-form-checkbox id="largeAccountPaid" v-model="project.largeAccountPaid" size="lg" :disabled="disableLargeAccount"></b-form-checkbox>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <div v-if="project.projectType !== 3 && project.projectType !== 4">
                    <b-row>
                      <b-col lg="12">
                        <b-form-group :label="FormMSG(65, 'Custom user title')" label-for="userTitleSideNavbar" :label-cols="3" :horizontal="true">
                          <b-form-input
                            v-model="project.userName"
                            :placeholder="FormMSG(69, 'e.g: User or Crew Member or Employee or ...')"
                            type="text"
                          ></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="12">
                        <b-form-group :label="FormMSG(70, 'Custom hod title')" label-for="hodTitleSideNavbar" :label-cols="3" :horizontal="true">
                          <b-form-input v-model="project.hodName" :placeholder="FormMSG(71, 'e.g: Head of Department or ...')" type="text"></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="12">
                        <b-form-group :label="FormMSG(72, 'Custom production title')" label-for="productionTitleSideNavbar" :label-cols="3" :horizontal="true">
                          <b-form-input
                            v-model="project.managerName"
                            :placeholder="FormMSG(73, 'e.g: Production or Management or ...')"
                            type="text"
                          ></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row v-if="project.useExpense">
                      <b-col lg="12">
                        <b-form-group
                          :label="FormMSG(814, 'Max items per expense sheet')"
                          label-for="productionTitleSideNavbar"
                          :label-cols="3"
                          :horizontal="true"
                        >
                          <b-form-input v-model="project.maxExpenseItemsPerSheet" type="text"></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </div>
                  <div v-if="project.projectType !== 3 && project.projectType !== 4" class="mb-2">
                    <fieldset class="my-0" :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                      <legend :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                        {{ FormMSG(560, 'Options for budget') }}
                      </legend>
                      <b-row>
                        <b-col>
                          <b-form-checkbox id="lockedBudget" v-model="project.budgetLocked" size="lg" class="pj-cb pb-1">
                            {{ FormMSG(561, 'Locked budget') }}
                          </b-form-checkbox>
                        </b-col>
                      </b-row>
                    </fieldset>
                  </div>
                  <div v-if="project.projectType !== 3 && project.projectType !== 4">
                    <fieldset class="my-0 py-0" :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                      <legend :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                        {{ FormMSG(4011, 'License options') }}
                        <component :is="getLucideIcon('Lock')" :size="16" :stroke-width="2" />
                      </legend>
                      <b-row>
                        <b-col sm="12" md="12" lg="3" xl="3" class="h-100">
                          <div class="d-flex flex-column">
                            <div class="card card-border-blue-light">
                              <h5>
                                <strong>{{ FormMSG(800, 'Entry for crew') }}</strong>
                              </h5>
                              <b-row>
                                <b-col>
                                  <b-form-checkbox
                                    id="useEntr"
                                    v-model="project.useEntryForCrew"
                                    size="lg"
                                    :disabled="!isDev"
                                    class="pj-cb pb-1"
                                    @change="handleControlEntryForCrew($event, 0)"
                                  >
                                    {{ FormMSG(800, 'Entry for crew') }}
                                  </b-form-checkbox>
                                  <b-row>
                                    <b-col offset-sm="1">
                                      <b-form-checkbox
                                        id="useEntrTimes"
                                        v-model="project.useEntryForCrewTimesheet"
                                        size="lg"
                                        :disabled="!isDev"
                                        class="pj-cb pb-1"
                                        @change="handleControlEntryForCrew($event, 1)"
                                      >
                                        <div>{{ FormMSG(300, 'Timesheets') }}</div>
                                      </b-form-checkbox>
                                    </b-col>
                                  </b-row>
                                  <b-row>
                                    <b-col offset-sm="1">
                                      <b-form-checkbox
                                        id="useEntrExp"
                                        v-model="project.useEntryForCrewExpenses"
                                        size="lg"
                                        :disabled="!isDev"
                                        class="pj-cb pb-1"
                                        @change="handleControlEntryForCrew($event, 2)"
                                      >
                                        <div>{{ FormMSG(400, 'Expenses') }}</div>
                                      </b-form-checkbox>
                                    </b-col>
                                  </b-row>
                                  <b-row>
                                    <b-col offset-sm="1">
                                      <b-form-checkbox
                                        id="useEntrPo"
                                        v-model="project.useEntryForCrewPo"
                                        size="lg"
                                        :disabled="!isDev"
                                        class="pj-cb pb-1"
                                        @change="handleControlEntryForCrew($event, 3)"
                                      >
                                        <div>{{ FormMSG(402, 'Purchase Orders') }}</div>
                                      </b-form-checkbox>
                                    </b-col>
                                  </b-row>
                                  <b-row>
                                    <b-col offset-sm="1">
                                      <b-form-checkbox
                                        id="useEntrInvoice"
                                        v-model="project.useEntryForCrewInvoice"
                                        size="lg"
                                        :disabled="!isDev"
                                        class="pj-cb pb-1"
                                        @change="handleControlEntryForCrew($event, 4)"
                                      >
                                        <div>{{ FormMSG(4051, 'Invoices') }}</div>
                                      </b-form-checkbox>
                                    </b-col>
                                  </b-row>
                                </b-col>
                              </b-row>
                            </div>
                            <div class="card card-border-blue-light">
                              <h5>
                                <strong>{{ FormMSG(1004, 'Other') }}</strong>
                              </h5>
                              <b-row>
                                <b-col>
                                  <b-form-checkbox id="useDpae" v-model="project.useDpae" size="lg" :disabled="!isDev" class="pj-cb pb-1">
                                    {{ FormMSG(563, 'DPAE') }}
                                  </b-form-checkbox>
                                </b-col>
                              </b-row>
                            </div>
                          </div>
                        </b-col>
                        <b-col sm="12" md="12" lg="3" xl="3" class="h-100">
                          <div class="card card-border-blue-light">
                            <h5>
                              <strong>{{ FormMSG(8005, 'Production') }}</strong>
                            </h5>
                            <b-row>
                              <b-col>
                                <b-form-checkbox
                                  id="useEntraa"
                                  v-model="project.useProduction"
                                  size="lg"
                                  :disabled="!isDev"
                                  class="pj-cb pb-1"
                                  @change="handleUseProd($event, 0)"
                                >
                                  {{ FormMSG(8005, 'Production') }}
                                </b-form-checkbox>
                                <b-row>
                                  <b-col offset-sm="1">
                                    <b-form-checkbox
                                      id="useEntrTimess"
                                      v-model="project.useCrewSetup"
                                      size="lg"
                                      :disabled="!isDev"
                                      class="pj-cb pb-1"
                                      @change="handleUseProd($event, 1)"
                                    >
                                      <div>{{ FormMSG(3050, 'Crew setup') }}</div>
                                    </b-form-checkbox>
                                  </b-col>
                                </b-row>
                                <b-row>
                                  <b-col offset-sm="1">
                                    <b-form-checkbox
                                      id="useEntrExpens"
                                      v-model="project.useContacts"
                                      size="lg"
                                      :disabled="!isDev"
                                      class="pj-cb pb-1"
                                      @change="handleUseProd($event, 1)"
                                    >
                                      <div>{{ FormMSG(40014, 'Contacts') }}</div>
                                    </b-form-checkbox>
                                  </b-col>
                                </b-row>
                                <b-row>
                                  <b-col offset-sm="1">
                                    <b-form-checkbox
                                      id="useDoc"
                                      v-model="project.useDocument"
                                      size="lg"
                                      :disabled="!isDev"
                                      class="pj-cb pb-1"
                                      @change="handleUseProd($event, 1)"
                                    >
                                      {{ FormMSG(4050, 'Documents & Packages') }}
                                    </b-form-checkbox>
                                  </b-col>
                                </b-row>
                                <b-row>
                                  <b-col offset-sm="1">
                                    <b-form-checkbox
                                      id="useCallSheet"
                                      v-model="project.useCallSheet"
                                      size="lg"
                                      :disabled="!isDev"
                                      class="pj-cb pb-1"
                                      @change="handleUseProd($event, 1)"
                                    >
                                      {{ FormMSG(4055, 'Call sheet') }}
                                    </b-form-checkbox>
                                  </b-col>
                                </b-row>
                                <b-row>
                                  <b-col offset-sm="1">
                                    <b-form-checkbox
                                      id="useAcc"
                                      v-model="project.useAccommodation"
                                      size="lg"
                                      :disabled="!isDev"
                                      class="pj-cb pb-1"
                                      @change="handleUseProd($event, 1)"
                                    >
                                      {{ FormMSG(403, 'Accommodations') }}
                                    </b-form-checkbox>
                                    <b-form-checkbox
                                      id="useLocations"
                                      v-model="project.useLocations"
                                      size="lg"
                                      :disabled="!isDev"
                                      class="pj-cb pb-1"
                                      @change="handleUseProd($event, 1)"
                                    >
                                      {{ FormMSG(4040, 'Locations') }}
                                    </b-form-checkbox>
                                    <b-form-checkbox
                                      id="useTra"
                                      v-model="project.useTransport"
                                      size="lg"
                                      :disabled="!isDev"
                                      class="pj-cb pb-1"
                                      @change="handleUseProd($event, 1)"
                                    >
                                      {{ FormMSG(404, 'Transports') }}
                                    </b-form-checkbox>
                                    <b-form-checkbox
                                      id="useTran"
                                      v-model="project.useExport"
                                      size="lg"
                                      :disabled="!isDev"
                                      class="pj-cb pb-1"
                                      @change="handleUseProd($event, 1)"
                                    >
                                      {{ FormMSG(4041, 'Export') }}
                                    </b-form-checkbox>
                                    <b-form-checkbox
                                      id="useTrnsa"
                                      v-model="project.useImport"
                                      size="lg"
                                      :disabled="!isDev"
                                      class="pj-cb pb-1"
                                      @change="handleUseProd($event, 1)"
                                    >
                                      {{ FormMSG(4042, 'Import') }}
                                    </b-form-checkbox>
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-row>
                          </div>
                        </b-col>
                        <b-col sm="12" md="12" lg="3" xl="3" class="h-100">
                          <div class="card card-border-blue-light">
                            <h5>
                              <strong>{{ FormMSG(5800, 'Finance') }}</strong>
                            </h5>
                            <b-row>
                              <b-col class="pr-0">
                                <b-form-checkbox
                                  id="useFinance"
                                  v-model="project.useFinance"
                                  size="lg"
                                  :disabled="!isDev"
                                  class="pj-cb pb-1"
                                  @change="handleFinance($event, 0)"
                                >
                                  {{ FormMSG(5800, 'Finance') }}
                                </b-form-checkbox>
                                <b-row>
                                  <b-col offset-sm="1">
                                    <b-form-checkbox
                                      id="useGS"
                                      v-model="project.useGreenSupplier"
                                      size="lg"
                                      :disabled="!isDev"
                                      class="pj-cb pb-1"
                                      @change="handleFinance($event, 1)"
                                    >
                                      {{ FormMSG(407, 'Green Suppliers') }}
                                    </b-form-checkbox>
                                    <b-form-checkbox
                                      id="usePO"
                                      v-model="project.usePurchaseOrder"
                                      size="lg"
                                      :disabled="!isDev"
                                      class="pj-cb pb-1"
                                      @change="handleFinance($event, 1)"
                                    >
                                      {{ FormMSG(402, 'Purchase Orders') }}
                                    </b-form-checkbox>
                                    <b-form-checkbox
                                      id="useExp"
                                      v-model="project.useExpense"
                                      size="lg"
                                      :disabled="!isDev"
                                      class="pj-cb pb-1"
                                      @change="handleFinance($event, 2)"
                                    >
                                      {{ FormMSG(400, 'Expenses') }}
                                    </b-form-checkbox>
                                    <b-row>
                                      <b-col>
                                        <b-row>
                                          <b-col offset="1">
                                            <b-form-checkbox
                                              id="useExpTravel"
                                              v-model="project.useExpenseTravel"
                                              size="lg"
                                              :disabled="!isDev"
                                              class="pj-cb pb-1"
                                              @change="handleControlExpense($event, 1)"
                                            >
                                              <div>{{ FormMSG(501, 'Travel') }}</div>
                                            </b-form-checkbox>
                                          </b-col>
                                        </b-row>
                                        <b-row>
                                          <b-col offset="1">
                                            <b-form-checkbox
                                              id="useExpTicket"
                                              v-model="project.useExpenseTicket"
                                              size="lg"
                                              :disabled="!isDev"
                                              class="pj-cb pb-1"
                                              @change="handleControlExpense($event, 1)"
                                            >
                                              <div>{{ FormMSG(502, 'Ticket') }}</div>
                                            </b-form-checkbox>
                                          </b-col>
                                        </b-row>
                                      </b-col>
                                    </b-row>
                                    <b-form-checkbox
                                      id="useExpInvoice"
                                      v-model="project.useExpenseInvoice"
                                      size="lg"
                                      :disabled="!isDev"
                                      class="pj-cb pb-1"
                                      @change="handleControlInvoice($event, 1)"
                                    >
                                      <div>{{ FormMSG(444, 'Invoices') }}</div>
                                    </b-form-checkbox>
                                    <b-form-checkbox
                                      id="useTs"
                                      v-model="project.useTimesheet"
                                      size="lg"
                                      :disabled="!isDev"
                                      class="pj-cb"
                                      @change="handleFinance($event, 1)"
                                    >
                                      {{ FormMSG(300, 'Timesheets:') }}
                                    </b-form-checkbox>
                                    <b-form-checkbox
                                      id="useTsPl"
                                      v-model="project.useTimesheetPlanning"
                                      size="lg"
                                      :disabled="!isDev"
                                      class="pj-cb"
                                      @change="handleFinance($event, 1)"
                                    >
                                      {{ FormMSG(30074, 'Timesheets planning') }}
                                    </b-form-checkbox>
                                    <b-form-checkbox
                                      id="useBud"
                                      v-model="project.useBudget"
                                      size="lg"
                                      :disabled="!isDev"
                                      class="pj-cb"
                                      @change="handleFinance($event, 1)"
                                    >
                                      {{ FormMSG(409, 'Budget') }}
                                    </b-form-checkbox>
                                    <b-form-checkbox
                                      id="useDigitalCertifiedExpenses"
                                      v-model="project.digitalCertifiedExpense"
                                      size="lg"
                                      :disabled="!isDev"
                                      class="pj-cb"
                                      @change="handleFinance($event, 1)"
                                    >
                                      {{ FormMSG(1409, 'Digital certified expenses') }}
                                    </b-form-checkbox>
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-row>
                          </div>
                        </b-col>
                        <b-col sm="12" md="12" lg="3" xl="3" class="h-100">
                          <div class="card card-border-blue-light">
                            <h5>
                              <strong>{{ FormMSG(80840, 'Green') }}</strong>
                            </h5>
                            <b-row>
                              <b-col>
                                <b-form-checkbox
                                  id="useGreen"
                                  v-model="project.useGreen"
                                  size="lg"
                                  :disabled="!isDev"
                                  class="pj-cb pb-1"
                                  @change="handleGreen($event, 0)"
                                >
                                  {{ FormMSG(80840, 'Green') }}
                                </b-form-checkbox>
                                <b-row>
                                  <b-col offset-sm="1">
                                    <b-form-checkbox
                                      id="useCarbTempl"
                                      v-model="project.useCarbonTemplate"
                                      size="lg"
                                      :disabled="!isDev"
                                      class="pj-cb pb-1"
                                      @change="handleGreen($event, 1)"
                                    >
                                      <div>{{ FormMSG(30710, 'Carbon template') }}</div>
                                    </b-form-checkbox>
                                  </b-col>
                                </b-row>
                                <b-row>
                                  <b-col offset-sm="1">
                                    <b-form-checkbox
                                      id="useGreenTable"
                                      v-model="project.useGreenTable"
                                      size="lg"
                                      :disabled="!isDev"
                                      class="pj-cb pb-1"
                                      @change="handleGreen($event, 1)"
                                    >
                                      <div>{{ FormMSG(40740, 'Green table') }}</div>
                                    </b-form-checkbox>
                                  </b-col>
                                </b-row>
                                <b-row>
                                  <b-col offset-sm="1">
                                    <b-form-checkbox
                                      id="useReport"
                                      v-model="project.useReporting"
                                      size="lg"
                                      :disabled="!isDev"
                                      class="pj-cb pb-1"
                                      @change="handleGreen($event, 1)"
                                    >
                                      <div>{{ FormMSG(40982, 'Reporting') }}</div>
                                    </b-form-checkbox>
                                    <b-form-checkbox
                                      id="useCarbRemove"
                                      v-model="project.useCarbonRemoval"
                                      size="lg"
                                      :disabled="!isDev"
                                      class="pj-cb pb-1"
                                      @change="handleGreen($event, 1)"
                                    >
                                      <div>{{ FormMSG(40983, 'Carbon removal') }}</div>
                                    </b-form-checkbox>
                                    <b-form-checkbox
                                      id="useWaste"
                                      v-model="project.useWaste"
                                      size="lg"
                                      :disabled="!isDev"
                                      class="pj-cb pb-1"
                                      @change="handleGreen($event, 1)"
                                    >
                                      <div>{{ FormMSG(40984, 'Waste') }}</div>
                                    </b-form-checkbox>
                                    <b-form-checkbox
                                      id="useTOD"
                                      v-model="project.useTipOfDay"
                                      size="lg"
                                      :disabled="!isDev"
                                      class="pj-cb pb-1"
                                      @change="handleGreen($event, 1)"
                                    >
                                      {{ FormMSG(406, 'Tip Of Day') }}
                                    </b-form-checkbox>
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-row>
                          </div>
                        </b-col>
                      </b-row>
                    </fieldset>
                  </div>
                  <div v-if="project.projectType !== 3 && project.projectType !== 4" class="mt-2">
                    <fieldset class="my-0" :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                      <legend :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                        {{ FormMSG(652, 'Advanced options') }}
                      </legend>
                      <b-row>
                        <b-col>
                          <b-form-checkbox id="allow_outside_c" v-model="allowEntryOutsideContract" size="lg" class="pj-cb pb-1">
                            {{ FormMSG(653, 'Allow entry outside contract') }}
                          </b-form-checkbox>
                          <b-row>
                            <b-col class="ml-5">
                              <b-form-checkbox id="allow_outside_c_timesheets" v-model="project.allowTSEntryOutsideContract" size="lg" class="pj-cb pb-1">
                                <div>{{ FormMSG(654, 'Timesheets') }}</div>
                              </b-form-checkbox>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col class="ml-5">
                              <b-form-checkbox id="allow_outside_c_expenses" v-model="project.allowExpenseEntryOutsideContract" size="lg" class="pj-cb pb-1">
                                <div>{{ FormMSG(400, 'Expenses') }}</div>
                              </b-form-checkbox>
                            </b-col>
                          </b-row>

                          <b-row>
                            <b-col class="ml-5">
                              <b-form-checkbox id="allow_outside_c_po" v-model="project.allowPOEntryOutsideContract" size="lg" class="pj-cb pb-1">
                                <div>{{ FormMSG(402, 'Purchase Orders') }}</div>
                              </b-form-checkbox>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <b-form-checkbox id="hide_salary_info" v-model="project.hideSalaryInfo" size="lg" class="pj-cb pb-1">
                            <div>{{ FormMSG(6505, 'Hide salary information') }}</div>
                          </b-form-checkbox>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <b-form-checkbox id="hide_deal_memo_info" v-model="project.hideDealMemoInfo" size="lg" class="pj-cb pb-1">
                            <div>{{ FormMSG(6506, 'Hide deal memo information') }}</div>
                          </b-form-checkbox>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <b-form-checkbox id="make_inv_mandatory" v-model="project.mandatoryInvoiceReceipt" size="lg" class="pj-cb pb-1">
                            <div>{{ FormMSG(7, 'Make invoice receipts mandatory') }}</div>
                          </b-form-checkbox>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <b-form-checkbox id="make_exp_mandatory" v-model="project.mandatoryExpenseReceipt" size="lg" class="pj-cb pb-1">
                            <div>{{ FormMSG(8, 'Make expense receipts mandatory') }}</div>
                          </b-form-checkbox>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <b-form-checkbox id="make_constcenter_mandatory" v-model="project.mandatoryCategoryExpense" size="lg" class="pj-cb pb-1">
                            <div>{{ FormMSG(9, 'Make costcenter mandatory') }}</div>
                          </b-form-checkbox>
                        </b-col>
                      </b-row>
                    </fieldset>
                  </div>
                  <div v-if="project.projectType !== 3 && project.projectType !== 4" class="mt-2">
                    <fieldset class="my-0" :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                      <legend :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                        {{ FormMSG(1652, 'Options for OCR') }}
                      </legend>
                      <b-row class="mb-3">
                        <b-col>
                          <b-form-checkbox id="use_ocr_chk" v-model="project.useOcr" size="lg" class="pj-cb pb-1" @change="handleChangeUseOcr">
                            {{ FormMSG(1653, 'Use OCR') }}
                          </b-form-checkbox>
                        </b-col>
                      </b-row>
                      <b-collapse :visible="project.useOcr">
                        <b-row v-if="project.useOcr">
                          <b-col sm="12" md="4" lg="4" xl="4">
                            <b-form-group :label="FormMSG(1654, 'OCR provider')">
                              <b-form-select v-model="project.ocrProvider" :options="ocrProviderOptions" />
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-collapse>
                    </fieldset>
                  </div>
                  <div v-if="project.useTimesheet" class="mt-2">
                    <fieldset class="my-0 py-0 pb-0" :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                      <legend :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                        {{ FormMSG(24, 'Time management') }}
                      </legend>
                      <b-row>
                        <b-col cols="12">
                          <b-row>
                            <b-col sm="12" md="12" lg="4" xl="4">
                              <div class="card card-border-blue-light">
                                <b-form-checkbox
                                  id="ovt"
                                  v-model="project.useOvertime"
                                  size="lg"
                                  class="pj-cb pb-1"
                                  @change="handleControlOvertime($event, 'daily', 1)"
                                >
                                  {{ FormMSG(25, 'Compute daily overtime:') }}
                                </b-form-checkbox>
                                <b-form-checkbox
                                  id="ovt1"
                                  v-model="project.useOvt1"
                                  size="lg"
                                  class="pj-cb pb-1"
                                  @change="handleControlOvertime($event, 'daily', 2)"
                                >
                                  {{ FormMSG(325, 'Compute daily overtime 1') }}
                                </b-form-checkbox>
                                <b-form-checkbox
                                  id="ovt2"
                                  v-model="project.useOvt2"
                                  size="lg"
                                  class="pj-cb pb-1"
                                  @change="handleControlOvertime($event, 'daily', 3)"
                                >
                                  {{ FormMSG(326, 'Compute daily overtime 2:') }}
                                </b-form-checkbox>
                                <b-form-checkbox
                                  id="useWeeklyOvt"
                                  v-model="project.useWeeklyOvt"
                                  size="lg"
                                  class="pj-cb pb-1"
                                  @change="handleControlOvertime($event, 'weekly', 1)"
                                >
                                  {{ FormMSG(157, 'Compute weekly overtime') }}
                                </b-form-checkbox>
                                <b-form-checkbox
                                  id="useWeeklyOvt1"
                                  v-model="project.useWeeklyOvt1"
                                  size="lg"
                                  class="pj-cb pb-1"
                                  @change="handleControlOvertime($event, 'weekly', 2)"
                                >
                                  {{ FormMSG(158, 'Compute weekly overtime 2') }}
                                </b-form-checkbox>
                                <b-form-checkbox
                                  id="useWeeklyOvt2"
                                  v-model="project.useWeeklyOvt2"
                                  size="lg"
                                  class="pj-cb pb-1"
                                  @change="handleControlOvertime($event, 'weekly', 3)"
                                >
                                  {{ FormMSG(159, 'Compute weekly overtime 3') }}
                                </b-form-checkbox>
                              </div>
                            </b-col>
                            <b-col sm="12" md="12" lg="4" xl="4">
                              <div class="card card-border-blue-light">
                                <b-form-checkbox id="cnh" v-model="project.useNightHours" size="lg" class="pj-cb pb-1">
                                  {{ FormMSG(26, 'Compute night hours:') }}
                                </b-form-checkbox>
                                <b-form-checkbox id="tbtwwd" v-model="project.useTooEarlyHours" size="lg" class="pj-cb pb-1">
                                  {{ FormMSG(27, 'Use rest time') }}
                                </b-form-checkbox>
                                <b-form-checkbox id="chtwt" v-model="project.useHomeToWorkTime" size="lg" class="pj-cb pb-1">
                                  {{ FormMSG(336, 'Compute home to work time') }}
                                </b-form-checkbox>
                                <b-form-checkbox id="ult" v-model="project.useLunchTime" size="lg" class="pj-cb pb-1">
                                  {{ FormMSG(29, 'Use lunch time:') }}
                                </b-form-checkbox>
                                <b-form-checkbox v-if="!isFilmSingle" id="usd" v-model="project.useStageDay" size="lg" class="pj-cb pb-1">
                                  {{ FormMSG(30, 'Use stage day:') }}
                                </b-form-checkbox>
                                <b-form-checkbox id="sdsr" v-model="project.useSixthDay" size="lg" class="pj-cb pb-1">
                                  {{ FormMSG(28, 'Use sixth day special rate:') }}
                                </b-form-checkbox>
                                <b-form-checkbox id="useSeventhDay" v-model="project.useSeventhDay" size="lg" class="pj-cb pb-1">
                                  {{ FormMSG(161, 'Use 7th special rate') }}
                                </b-form-checkbox>
                                <b-form-checkbox id="useSundayRate" v-model="project.useSundayRate" size="lg" class="pj-cb pb-1">
                                  {{ FormMSG(160, 'Use sunday special rate') }}
                                </b-form-checkbox>
                              </div>
                            </b-col>
                            <b-col sm="12" md="12" lg="4" xl="4">
                              <div class="card card-border-blue-light">
                                <b-form-checkbox id="ulpd" v-model="project.useLunchPerDiem" size="lg" class="pj-cb pb-1">
                                  {{ FormMSG(139, 'Use lunch per diem:') }}
                                </b-form-checkbox>
                                <b-form-checkbox id="dinnerPerDiem" v-model="project.useDinnerPerDiem" size="lg" class="pj-cb pb-1">
                                  {{ FormMSG(301, 'Use dinner per diem') }}
                                </b-form-checkbox>
                                <b-form-checkbox id="uhpd" v-model="project.useHotelPerDiem" size="lg" class="pj-cb pb-1">
                                  {{ FormMSG(130, 'Use hotel per diem:') }}
                                </b-form-checkbox>
                                <b-form-checkbox id="abroadPerDiem" v-model="project.useAbroadPerDiem" size="lg" class="pj-cb pb-1">
                                  {{ FormMSG(302, 'Use abroad per diem') }}
                                </b-form-checkbox>
                                <b-form-checkbox v-if="!isFilmSingle" id="ubct" v-model="project.useBeforeCallTime" size="lg" class="pj-cb pb-1">
                                  {{ FormMSG(201, 'Use before call time') }}
                                </b-form-checkbox>
                              </div>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col sm="12" md="4" lg="4" offset-md="8" offset-lg="8">
                              <b-button block variant="outline-primary" @click="showHolidaysModal = true">
                                {{ FormMSG(245, 'Manage public holidays') }}
                              </b-button>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                      <b-row v-if="isFilmSingle">
                        <b-col cols="12" :class="`${$screen.width <= 576 ? 'pt-3' : ''}`" class="text-center">
                          <b-button class="btn" :class="`${$screen.width <= 576 ? 'w-100' : 'w-50'}`" variant="primary" @click="loadCcnForSolo">
                            {{ FormMSG(251, 'Load French CCN cinema salaries and functions') }}
                          </b-button>
                        </b-col>
                      </b-row>
                    </fieldset>
                  </div>
                  <div v-if="project.projectType === 0 || project.projectType === 1 || project.projectType === 4">
                    <fieldset v-if="project.projectType === 1" class="my-2 py-0" :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                      <legend :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                        {{ FormMSG(31, 'Offer Parameter') }}
                      </legend>
                      <div class="pb-3">
                        <div class="alert alert-warning" role="alert">
                          <div class="d-flex align-items-center" style="color: rgba(0, 0, 0, 0.6)">
                            <div class="pr-3" style="font-size: 1.5rem">
                              <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                            </div>
                            <div class="mt-0" :style="`font-size: ${$screen.width <= 576 ? '.9' : '1'}rem;`">
                              {{
                                FormMSG(
                                  32,
                                  `You should specify your own offer number format, otherwise the default format will be chosen automatically. e.g: "1"`
                                )
                              }}
                            </div>
                          </div>
                        </div>
                        <div class="d-flex flex-row">
                          <b-form-radio-group
                            v-model="selectedRadioOffer"
                            :options="radioOfferOptions"
                            class="lh-22"
                            @change="handleChangeOfferParameter"
                          ></b-form-radio-group>
                        </div>
                        <div class="d-block mt-2">
                          <fieldset class="my-0 pb-3 w-100" :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                            <fieldset class="my-0 pb-3 w-100" :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                              <legend class="scheduler-border">{{ FormMSG(36, 'Preview') }}</legend>
                              <div class="d-flex flex-row text-muted">
                                {{ FormMSG(37, 'e.g:') }} <span class="pl-1 last-number-format">{{ renderOfferFormat }}</span>
                              </div>
                            </fieldset>
                            <div v-if="!selectedRadioOffer">
                              <fieldset class="my-0 pb-2 w-100" :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                                <legend :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                                  {{ FormMSG(61, 'Define length') }}
                                </legend>
                                <div class="d-flex flex-row">
                                  <div class="pr-2" style="margin-top: 2px">1</div>
                                  <div class="w-100">
                                    <b-form-input
                                      v-model="offerInitialLength"
                                      type="range"
                                      min="1"
                                      max="10"
                                      step="1"
                                      @change="handleChangeOfferInitialLength"
                                    ></b-form-input>
                                  </div>
                                  <div class="pl-2" style="margin-top: 2px">10</div>
                                </div>
                                <div class="justify-content-center">
                                  <div class="w-100 text-center text-success">{{ offerInitialLength }}</div>
                                </div>
                              </fieldset>
                              <fieldset class="my-0 pb-3 w-100" :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                                <legend :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                                  {{ FormMSG(35, 'Choose year') }}
                                </legend>
                                <div class="d-flex flex-row">
                                  <b-form-radio-group
                                    v-model="selectedRadioOfferYear"
                                    :options="radioOfferYearOptions"
                                    class="lh-22"
                                    @change="handleChangeOfferYear"
                                  ></b-form-radio-group>
                                </div>
                              </fieldset>
                              <fieldset class="my-0 pb-0 w-100" :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                                <legend :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                                  {{ FormMSG(33, 'Define prefix') }}
                                </legend>
                                <b-row>
                                  <b-col sm="6">
                                    <b-form-group label-for="offerInitialText">
                                      <b-form-input
                                        v-model.trim="offerInitialText"
                                        type="text"
                                        :placeholder="FormMSG(60, 'e.g: TGS ...')"
                                        @input="handleChangeOfferInitialText"
                                      ></b-form-input>
                                    </b-form-group>
                                  </b-col>
                                </b-row>
                              </fieldset>
                            </div>
                            <fieldset class="my-0 pb-0 w-100" :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                              <legend :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                                {{ FormMSG(68, 'Enter your last number') }}
                              </legend>
                              <b-row>
                                <b-col sm="6">
                                  <b-form-group label-for="offerLastId">
                                    <b-form-input
                                      v-model="project.lastOfferNumber"
                                      type="number"
                                      step="1"
                                      min="0"
                                      max="100000"
                                      :placeholder="'e.g: 101'"
                                      :state="lastNumberValidation(project.lastOfferNumber)"
                                      @input="handleChangeOfferLastNumber"
                                    ></b-form-input>
                                    <b-form-invalid-feedback :state="lastNumberValidation(project.lastOfferNumber)">
                                      {{ FormMSG(34, 'Length must be 0-100000') }}
                                    </b-form-invalid-feedback>
                                  </b-form-group>
                                </b-col>
                              </b-row>
                            </fieldset>
                          </fieldset>
                        </div>
                      </div>
                    </fieldset>
                    <fieldset v-if="project.projectType === 1" class="my-2 py-0" :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                      <legend :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                        {{ FormMSG(38, 'Order Parameter') }}
                      </legend>
                      <div class="pb-3">
                        <div class="alert alert-warning" role="alert">
                          <div class="d-flex align-items-center" style="color: rgba(0, 0, 0, 0.6)">
                            <div class="pr-3" style="font-size: 1.5rem">
                              <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                            </div>
                            <div class="mt-0" :style="`font-size: ${$screen.width <= 576 ? '.9' : '1'}rem;`">
                              {{
                                FormMSG(
                                  39,
                                  `You should specify your own order number format, otherwise the default format will be chosen automatically. e.g: "1"`
                                )
                              }}
                            </div>
                          </div>
                        </div>
                        <div class="d-flex flex-row">
                          <b-form-radio-group
                            v-model="selectedRadioOrder"
                            :options="radioOrderOptions"
                            class="lh-22"
                            @change="handleChangeOrderParameter"
                          ></b-form-radio-group>
                        </div>
                        <div class="d-block mt-2">
                          <fieldset class="my-0 pb-3 w-100" :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                            <fieldset class="my-0 pb-3 w-100" :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                              <legend class="scheduler-border">{{ FormMSG(36, 'Preview') }}</legend>
                              <div class="d-flex flex-row text-muted">
                                {{ FormMSG(37, 'e.g:') }} <span class="pl-1 last-number-format">{{ renderOrderFormat }}</span>
                              </div>
                            </fieldset>
                            <div v-if="!selectedRadioOrder">
                              <fieldset class="my-0 pb-2 w-100" :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                                <legend :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                                  {{ FormMSG(61, 'Define length') }}
                                </legend>
                                <div class="d-flex flex-row">
                                  <div class="pr-2" style="margin-top: 2px">1</div>
                                  <div class="w-100">
                                    <b-form-input
                                      v-model="orderInitialLength"
                                      type="range"
                                      min="1"
                                      max="10"
                                      step="1"
                                      @change="handleChangeOrderInitialLength"
                                    ></b-form-input>
                                  </div>
                                  <div class="pl-2" style="margin-top: 2px">10</div>
                                </div>
                                <div class="justify-content-center">
                                  <div class="w-100 text-center text-success">{{ orderInitialLength }}</div>
                                </div>
                              </fieldset>
                              <fieldset class="my-0 pb-3 w-100" :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                                <legend :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                                  {{ FormMSG(35, 'Choose year') }}
                                </legend>
                                <div class="d-flex flex-row">
                                  <b-form-radio-group
                                    v-model="selectedRadioOrderYear"
                                    :options="radioOrderYearOptions"
                                    class="lh-22"
                                    @change="handleChangeOrderYear"
                                  ></b-form-radio-group>
                                </div>
                              </fieldset>
                              <fieldset class="my-0 pb-0 w-100" :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                                <legend :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                                  {{ FormMSG(33, 'Define prefix') }}
                                </legend>
                                <b-row>
                                  <b-col sm="6">
                                    <b-form-group label-for="orderInitialText">
                                      <b-form-input
                                        v-model.trim="orderInitialText"
                                        type="text"
                                        :placeholder="FormMSG(60, 'e.g: TGS ...')"
                                        @input="handleChangeOrderInitialText"
                                      ></b-form-input>
                                    </b-form-group>
                                  </b-col>
                                </b-row>
                              </fieldset>
                            </div>
                            <fieldset class="my-0 pb-0 w-100" :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                              <legend :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                                {{ FormMSG(68, 'Enter your last number') }}
                              </legend>
                              <b-row>
                                <b-col sm="6">
                                  <b-form-group label-for="orderLastId">
                                    <b-form-input
                                      v-model="project.lastOrderNumber"
                                      type="number"
                                      step="1"
                                      min="0"
                                      max="100000"
                                      :placeholder="'e.g: 101'"
                                      :state="lastNumberValidation(project.lastOrderNumber)"
                                      @input="handleChangeOrderLastNumber"
                                    ></b-form-input>
                                    <b-form-invalid-feedback :state="lastNumberValidation(project.lastOrderNumber)">
                                      {{ FormMSG(34, 'Length must be 0-100000') }}
                                    </b-form-invalid-feedback>
                                  </b-form-group>
                                </b-col>
                              </b-row>
                            </fieldset>
                          </fieldset>
                        </div>
                      </div>
                    </fieldset>
                    <fieldset
                      v-if="project.projectType === 1 || project.projectType === 4"
                      class="my-0 py-0 mt-3"
                      :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`"
                    >
                      <legend :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                        {{ FormMSG(40, 'Invoice Parameter') }}
                      </legend>
                      <div class="pb-3">
                        <div class="alert alert-warning" role="alert">
                          <div class="d-flex align-items-center" style="color: rgba(0, 0, 0, 0.6)">
                            <div class="pr-3" style="font-size: 1.5rem">
                              <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                            </div>
                            <div class="mt-0" :style="`font-size: ${$screen.width <= 576 ? '.9' : '1'}rem;`">
                              {{
                                FormMSG(
                                  41,
                                  `You should specify your own invoice number format, otherwise the default format will be chosen automatically. e.g: "1"`
                                )
                              }}
                            </div>
                          </div>
                        </div>
                        <div class="d-flex flex-row">
                          <b-form-radio-group
                            v-model="selectedRadioInvoice"
                            :options="radioInvoiceOptions"
                            class="lh-22"
                            @change="handleChangeInvoiceParameter"
                          ></b-form-radio-group>
                        </div>
                        <div class="d-block mt-2">
                          <fieldset class="my-0 pb-3 w-100" :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                            <fieldset class="my-0 pb-3 w-100" :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                              <legend :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                                {{ FormMSG(36, 'Preview') }}
                              </legend>
                              <div class="d-flex flex-row text-muted">
                                {{ FormMSG(37, 'e.g:') }} <span class="pl-1 last-number-format">{{ renderInvoiceFormat }}</span>
                              </div>
                            </fieldset>
                            <div v-if="!selectedRadioInvoice">
                              <fieldset class="my-0 pb-2 w-100" :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                                <legend :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                                  {{ FormMSG(61, 'Define length') }}
                                </legend>
                                <div class="d-flex flex-row">
                                  <div class="pr-2" style="margin-top: 2px">1</div>
                                  <div class="w-100">
                                    <b-form-input
                                      v-model="invoiceInitialLength"
                                      type="range"
                                      min="1"
                                      max="10"
                                      step="1"
                                      @change="handleChangeInvoiceInitialLength"
                                    ></b-form-input>
                                  </div>
                                  <div class="pl-2" style="margin-top: 2px">10</div>
                                </div>
                                <div class="justify-content-center">
                                  <div class="w-100 text-center text-success">{{ invoiceInitialLength }}</div>
                                </div>
                              </fieldset>
                              <fieldset class="my-0 pb-3 w-100" :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                                <legend :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                                  {{ FormMSG(35, 'Choose year') }}
                                </legend>
                                <div class="d-flex flex-row">
                                  <b-form-radio-group
                                    v-model="selectedRadioInvoiceYear"
                                    :options="radioInvoiceYearOptions"
                                    class="lh-22"
                                    @change="handleChangeInvoiceYear"
                                  ></b-form-radio-group>
                                </div>
                              </fieldset>
                              <fieldset class="my-0 pb-0 w-100" :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                                <legend :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                                  {{ FormMSG(33, 'Define prefix') }}
                                </legend>
                                <b-row>
                                  <b-col sm="6">
                                    <b-form-group label-for="invoiceInitialText">
                                      <b-form-input
                                        v-model.trim="invoiceInitialText"
                                        type="text"
                                        :placeholder="FormMSG(60, 'e.g: TGS ...')"
                                        @input="handleChangeInvoiceInitialText"
                                      ></b-form-input>
                                    </b-form-group>
                                  </b-col>
                                </b-row>
                              </fieldset>
                            </div>
                            <fieldset class="my-0 pb-0 w-100" :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                              <legend :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                                {{ FormMSG(68, 'Enter your last number') }}
                              </legend>
                              <b-row>
                                <b-col sm="6">
                                  <b-form-group label-for="invoiceLastId">
                                    <b-form-input
                                      v-model="project.lastInvoiceNumber"
                                      type="number"
                                      step="1"
                                      min="0"
                                      max="100000"
                                      :placeholder="'e.g: 101'"
                                      :state="lastNumberValidation(project.lastInvoiceNumber)"
                                      @input="handleChangeInvoiceLastNumber"
                                    ></b-form-input>
                                    <b-form-invalid-feedback :state="lastNumberValidation(project.lastInvoiceNumber)">
                                      {{ FormMSG(34, 'Length must be 0-100000') }}
                                    </b-form-invalid-feedback>
                                  </b-form-group>
                                </b-col>
                              </b-row>
                            </fieldset>
                          </fieldset>
                        </div>
                      </div>
                    </fieldset>
                    <fieldset v-if="project.projectType === 0" class="my-0 py-0 mt-3" :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                      <legend :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                        {{ FormMSG(740, 'Purchase Order parameter') }}
                      </legend>
                      <div class="pb-3">
                        <div class="alert alert-warning" role="alert">
                          <div class="d-flex align-items-center" style="color: rgba(0, 0, 0, 0.6)">
                            <div class="pr-3" style="font-size: 1.5rem">
                              <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                            </div>
                            <div class="mt-0" :style="`font-size: ${$screen.width <= 576 ? '.9' : '1'}rem;`">
                              {{
                                FormMSG(
                                  41,
                                  `You should specify your own invoice number format, otherwise the default format will be chosen automatically. e.g: "1"`
                                )
                              }}
                            </div>
                          </div>
                        </div>
                        <div class="d-flex flex-row">
                          <b-form-radio-group v-model="selectedRadioPo" :options="radioInvoiceOptions" class="lh-22" @change="handleChangePoParameter" />
                        </div>
                        <div class="d-block mt-2">
                          <fieldset class="my-0 pb-3 w-100" :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                            <fieldset class="my-0 pb-3 w-100" :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                              <legend :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                                {{ FormMSG(36, 'Preview') }}
                              </legend>
                              <div class="d-flex flex-row text-muted">
                                {{ FormMSG(37, 'e.g:') }} <span class="pl-1 last-number-format">{{ renderPoFormat }}</span>
                              </div>
                            </fieldset>
                            <div v-if="!selectedRadioPo">
                              <fieldset class="my-0 pb-2 w-100" :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                                <legend :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                                  {{ FormMSG(61, 'Define length') }}
                                </legend>
                                <div class="d-flex flex-row">
                                  <div class="pr-2" style="margin-top: 2px">1</div>
                                  <div class="w-100">
                                    <b-form-input
                                      v-model="poInitialLength"
                                      type="range"
                                      min="1"
                                      max="10"
                                      step="1"
                                      @change="handleChangePoInitialLength"
                                    ></b-form-input>
                                  </div>
                                  <div class="pl-2" style="margin-top: 2px">10</div>
                                </div>
                                <div class="justify-content-center">
                                  <div class="w-100 text-center text-success">{{ poInitialLength }}</div>
                                </div>
                              </fieldset>
                              <fieldset class="my-0 pb-3 w-100" :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                                <legend :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                                  {{ FormMSG(35, 'Choose year') }}
                                </legend>
                                <div class="d-flex flex-row">
                                  <b-form-radio-group
                                    v-model="selectedRadioPoYear"
                                    :options="radioInvoiceYearOptions"
                                    class="lh-22"
                                    @change="handleChangePoYear"
                                  />
                                </div>
                              </fieldset>
                              <fieldset class="my-0 pb-0 w-100" :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                                <legend :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                                  {{ FormMSG(33, 'Define prefix') }}
                                </legend>
                                <b-row>
                                  <b-col sm="6">
                                    <b-form-group label-for="invoiceInitialText">
                                      <b-form-input
                                        v-model.trim="poInitialText"
                                        type="text"
                                        :placeholder="FormMSG(60, 'e.g: PO ...')"
                                        @input="handleChangePoInitialText"
                                      ></b-form-input>
                                    </b-form-group>
                                  </b-col>
                                </b-row>
                              </fieldset>
                            </div>
                            <fieldset class="my-0 pb-0 w-100" :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                              <legend :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                                {{ FormMSG(68, 'Enter your last number') }}
                              </legend>
                              <b-row>
                                <b-col sm="6">
                                  <b-form-group label-for="invoiceLastId">
                                    <b-form-input
                                      v-model="project.lastPoNumber"
                                      type="number"
                                      step="1"
                                      min="0"
                                      max="100000"
                                      :placeholder="'e.g: 101'"
                                      :state="lastNumberValidation(project.lastPoNumber)"
                                      @input="handleChangePoLastNumber"
                                    ></b-form-input>
                                    <b-form-invalid-feedback :state="lastNumberValidation(project.lastPoNumber)">
                                      {{ FormMSG(34, 'Length must be 0-100000') }}
                                    </b-form-invalid-feedback>
                                  </b-form-group>
                                </b-col>
                              </b-row>
                            </fieldset>
                          </fieldset>
                        </div>
                      </div>
                    </fieldset>
                    <fieldset
                      v-if="project.projectType === 0"
                      class="mb-0 pt-0 mt-3 pb-3"
                      :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`"
                    >
                      <legend :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                        {{ FormMSG(741, 'Salary Parameter') }}
                      </legend>
                      <div class="pb-1">
                        <div class="alert alert-warning" role="alert">
                          <div class="d-flex align-items-center" style="color: rgba(0, 0, 0, 0.6)">
                            <div class="pr-3" style="font-size: 1.5rem">
                              <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                            </div>
                            <div class="mt-0" :style="`font-size: ${$screen.width <= 576 ? '.9' : '1'}rem;`">
                              {{ FormMSG(743, `Specify how much number you need after the comma for the salary`) }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <fieldset class="my-0 w-100 mb-3" :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                        <legend :class="`${$screen.width <= 576 ? 'card-inside' : 'scheduler-border'}`">
                          {{ FormMSG(742, 'Contract Hourly Rate Precision') }}
                        </legend>
                        <b-row>
                          <b-col sm="6">
                            <b-form-group label-for="hourleRatePrecision">
                              <b-form-input
                                v-model="project.contractHourlyRatePrecision"
                                type="number"
                                step="1"
                                min="0"
                                :placeholder="'eg: 0-8'"
                                max="8"
                                :state="decimalNumberValidation(project.contractHourlyRatePrecision)"
                                @input="handleChangeContractHourlyRatePrecision"
                              ></b-form-input>
                              <b-form-invalid-feedback
                                v-if="!decimalNumberValidation(project.contractHourlyRatePrecision)"
                                :state="decimalNumberValidation(project.contractHourlyRatePrecision)"
                              >
                                {{ FormMSG(744, 'Length must be 0-8') }}
                              </b-form-invalid-feedback>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </fieldset>
                    </fieldset>
                  </div>
                </b-col>
                <b-col v-if="!isModal" sm="3" class="text-center" :class="`${$screen.width < 992 ? 'mt-3' : ''}`">
                  <div :class="`${$screen.width > 576 ? 'sidenav-sticky sticky-top' : ''}`" style="z-index: 0">
                    <b-row v-if="$route.path.includes('newProject')" :class="`${$screen.width <= 576 ? 'footer-fixed' : 'card mb-2 pb-0 px-0'}`">
                      <b-col cols="12">
                        <b-button
                          class="w-100 d-flex justify-content-center align-items-center"
                          type="button"
                          :variant="clickedReplicateBtn ? 'dark' : 'outline-dark'"
                          :disabled="clickedReplicateBtn"
                          @click="replicateTemplateProject"
                        >
                          <b-spinner v-show="replicatingInProgress" class="mr-2" small></b-spinner>
                          <component :is="getLucideIcon('Copy')" v-if="!replicatingInProgress" :size="20" class="mr-2" :stroke-width="2.5" />
                          <div style="margin-top: 1px">{{ FormMSG(7444, 'Replicate from template') }}</div>
                        </b-button>
                      </b-col>
                    </b-row>
                    <b-row :class="`${$screen.width <= 576 ? 'footer-fixed' : 'card mb-2 pb-0 px-0'}`">
                      <b-col cols="12">
                        <b-button
                          class="w-100 d-flex justify-content-center align-items-center"
                          type="submit"
                          variant="outline-primary"
                          :disabled="disableSave"
                        >
                          <b-spinner v-show="isLoading" class="mr-2" small></b-spinner>
                          <component :is="getLucideIcon('Check')" v-if="!isLoading" :size="20" class="mr-2" :stroke-width="2.5" />
                          <div style="margin-top: 1px">{{ addSaveLabel() }}</div>
                        </b-button>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12">
                        <b-button v-if="showGoBack" class="btn w-100" variant="primary" @click="viewUsers">{{ FormMSG(17, 'Users') }}</b-button>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12">
                        <b-button v-if="showGoBack" class="btn w-100" variant="primary" @click="goBack">{{ FormMSG(10, 'Go back') }}</b-button>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12">
                        <b-button v-if="showAddPme" class="btn w-100" variant="primary" @click="addPme">
                          {{ FormMSG(110, 'Add new Legal Entity') }}
                        </b-button>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12">
                        <MobileProfilePicCaptureBtn
                          v-if="$screen.width <= 567 || $isPwa()"
                          parent-type="project"
                          :parent-id="project.id"
                          :label-button="FormMSG(43, 'Change project picture')"
                          crop-type="default"
                          use-button
                          @change="handleImgsTaken"
                        />
                        <b-button v-if="$screen.width > 567" class="w-100 mt-0" variant="outline-secondary" size="md" @click="startCapture">
                          <i class="icon-camera"></i> {{ FormMSG(43, 'Change project picture') }}
                        </b-button>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="12">
                        <b-form-group v-model="project.picture">
                          <img :src="imageName" class="project-picture-preview" alt="pict" />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </div>
                </b-col>
              </b-row>
            </b-form>
          </div>
        </b-col>
      </b-row>
      <NewCapture
        :key="refreshTokenCaptureItem"
        v-model="capturePict"
        parent-type="project"
        :parent-id="project.id"
        auto-crop-capture
        @change="handleImgsTaken"
      />
      <holidays-modal :open="showHolidaysModal" @holidays-modal:close="showHolidaysModal = false" />
      <!--only-one-crop-mode -->
      <loading :active.sync="isLoading" :is-full-page="true" color="#00A09C"></loading>
      <b-modal
        ref="my-modal"
        v-model="cropPict"
        header-class="header-class-modal-doc-package"
        title="Crop Picture"
        size="cropSize"
        ok-variant="success"
        ok-title="Confirm Save"
        cancel-title="Cancel"
        @ok="endCrop"
        @cancel="endCropCancel"
      >
        <CropPicture ref="myCropPicture"> </CropPicture>
      </b-modal>
      <b-modal
        v-model="newPmeModal"
        header-class="header-class-modal-doc-package"
        :title="FormMSG(62, 'Create new Legal Entity?')"
        class="modal-dialog modal-lg"
        ok-variant="primary"
        :ok-title="FormMSG(67, 'Create Entity')"
        @ok="newPmeConfirmed()"
      >
        <b-form-group :label="FormMSG(109, 'New Entity Name:')" label-for="pmeName" :label-cols="6">
          <b-form-input id="pmeName" v-model="newPmeName" type="text"></b-form-input>
        </b-form-group>
        <b-form-group
          class="form-row align-items-center"
          :label="FormMSG(120, 'Copy Departments, Functions, Budget categories and HR templates of this entity?')"
          label-for="copyPmeConfig"
          :label-cols="10"
        >
          <b-form-checkbox id="copyPmeConfig" v-model="copyPmeConfig" size="lg"></b-form-checkbox>
        </b-form-group>
      </b-modal>
      <!--The following dialog is not used for delete warnig this time but for confirm options-->
      <common-warning-on-delete-dialog
        ref="InfoDialog"
        v-model="showReplicateInfoDialog"
        :message="
          FormMSG(
            7445,
            'a replicate template action has been detected, do you want to replicate all data from the template such as users or documents into this project too ?'
          )
        "
        @dialog:cancel="handleConfirmReplicateAction(false)"
        @dialog:confirm="handleConfirmReplicateAction(true)"
      />
    </div>
  </errorContainer>
</template>

<script>
// import gql from 'graphql-tag'
import { store } from '@/store';

//import  isNil  from "@/shared/utils.js";
const isNil = (any) => {
  return any === undefined || any === null;
};
import gql from 'graphql-tag';
import { apolloClient as apollo } from '@/vue-apollo';
import { Camera, CameraResultType } from '@capacitor/camera';
import languageMessages from '@/mixins/languageMessages';
import CropPicture from '@/components/CropPicture';
import CapturePicture from '@/components/CapturePicture';
import SupplierSelector from '@/components/SupplierSelector';
//import Capture from "@/components/ExpenseService/Capture";
import NewCapture from '@/components/CaptureModule/Main';
import Loading from 'vue-loading-overlay';
import { getProject, updMyProject, addProject, newSmeProject } from '@/cruds/project.crud';
import isSingleProjectMixin from '@/mixins/isSingleProject.mixin';
import moment from 'moment';
import globalMixin from '@/mixins/global.mixin';
import MobileProfilePicCaptureBtn from '@/components/CaptureModule/MobileProfilePicCaptureBtn';
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
// import * as icons from 'lucide-vue';
import PayrollCode from '@/components/Spaiectacle/PayrollCode';
import * as _ from 'lodash';
import HolidaysModal from '@/components/Modals/HolidaysModal';
import { reScalingImgWithCanvas } from '@/components/Packages/Captures/capture.utils';
import CommonWarningOnDeleteDialog from '../../components/Dialogs/CommonWarningOnDeleteDialog.vue';
import CountrySelector from '@/components/Selectors/CountrySelector';
import MultipleCountrySelector from '@/components/Selectors/MultipleCountrySelector';
// needed for the DPAE fieldset
import MainAddressLocation from '@/components/LocationService/MainAddressLocation';
import { noTilde, capitalize } from '~utils';
import { DEFAULT_HOUR_RATE_PRECISION } from '@/shared/constants';

const keyYearFormat = new Map();
keyYearFormat.set('{YYYY}', 2);
keyYearFormat.set('{YY}', 1);
keyYearFormat.set('', 0);

const valueYearFormat = new Map();
valueYearFormat.set(2, '{YYYY}');
valueYearFormat.set(1, '{YY}');
valueYearFormat.set(0, '');

export default {
  name: 'ProjectForm',
  components: {
    'v-address': MainAddressLocation,
    Loading,
    CropPicture,
    CapturePicture,
    SupplierSelector,
    NewCapture,
    MobileProfilePicCaptureBtn,
    'v-date-picker': DatePicker,
    PayrollCode,
    HolidaysModal,
    CommonWarningOnDeleteDialog,
    CountrySelector,
    MultipleCountrySelector
  },
  mixins: [languageMessages, isSingleProjectMixin, globalMixin],
  props: {
    projectFormId: {
      type: [Number, String],
      required: false,
      default: 0
    },
    isCreateWithModal: { type: Boolean, required: false, default: false },
    isModal: { type: Boolean, required: false, default: false },
    canUpdate: { type: Boolean, required: false, default: false },
    canCreate: { type: Boolean, required: false, default: false },
    licenseId: { type: [Number, String], required: false, default: 0 }
  },
  data() {
    return {
      clickedReplicateBtn: false,
      replicatingInProgress: false,
      showReplicateInfoDialog: false,
      erreur: {},
      capturePict: false,
      cropPict: false,
      disableSaveButton: true,
      isLoading: false,
      refreshTokenCaptureItem: 0,
      enableProjectTypeChoice: false,
      newPmeModal: false,
      copyPmeConfig: false,
      newPmeName: '',
      project: {
        ccPersonalAccessToken: '',
        licenseID: 0,
        titre: '',
        production: '',
        realisateur: '',
        timeZone: 'CET',
        language: 0,
        currency: 0,
        distanceUnit: 0,
        projectType: 0,
        productionMethod: [],
        mainBroadcastMode: 0,
        productionType: 0,
        filmLength: 0,
        numEpisode: 0,
        shootingFormat: 0,
        carbonModel: 1,
        greenReporting: 1,
        useOvertime: true,
        useOvt1: true,
        useOvt2: true,
        useHomeToWorkTime: true,
        useTransport: true,
        useLunchPerDiem: true,
        useHotelPerDiem: true,
        useTimesheet: true,
        useExpense: true,
        usePurchaseOrder: true,
        useDocument: true,
        useCallSheet: true,
        useAccommodation: true,
        useTipOfDay: true,
        useEntryForCrewTimesheet: true,
        useEntryForCrewPo: true,
        useEntryForCrewInvoice: true,
        useEntryForCrewExpenses: true,
        useEntryForCrew: true,
        useGreenSupplier: true,
        useTask: true,
        usePlanning: true,
        useClient: true,
        useBudget: true,
        useNightHours: true,
        useTooEarlyHours: true,
        useSixthDay: true,
        useLunchTime: true,
        useStageDay: true,
        useBeforeCallTime: true,
        useWeeklyOvt: true,
        useWeeklyOvt1: true,
        useWeeklyOvt2: true,
        useSeventhDay: true,
        useSundayRate: true,
        picture: '',
        songMusic: '',
        coProducers: '',
        invoiceDetails: '',
        addressId: 0,
        startDate: '2021-10-13T00:00:00Z',
        endDate: '2021-10-13T00:00:00Z',
        customerId: '',
        numberOfUser: 10,
        supportLevel: 1,
        // vatPercent: 0,
        useForCrewInvoice: false,
        largeAccount: false,
        largeAccountPaid: false,
        lastOrderFormat: '',
        lastOfferFormat: '',
        lastInvoiceFormat: '',
        lastInvoiceNumber: 0,
        lastOfferNumber: 0,
        lastOrderNumber: 0,
        lastPoFormat: '',
        lastPoNumber: 0,
        userName: '',
        hodName: '',
        managerName: '',
        shootingStartDate: null,
        wrapStartDate: null,
        useExpenseTravel: true,
        useExpenseTicket: true,
        useExpenseInvoice: true,
        reference: '',
        payrollInterface: 0,
        allowTSEntryOutsideContract: false,
        allowPOEntryOutsideContract: false,
        allowExpenseEntryOutsideContract: false,
        hideDealMemoInfo: false,
        mandatoryCategoryExpense: false,
        analyticPeriodType: 0,
        ccShareReporting: '',
        // useKlippaOcr: false,
        regionalSetting: 0,
        useProduction: true,
        useContacts: true,
        useCrewSetup: true,
        useLocations: true,
        useExport: true,
        useImport: true,
        useFinance: true,
        useTimesheetPlanning: true,
        useGreen: true,
        useCarbonTemplate: true,
        useGreenTable: true,
        useReporting: true,
        useCarbonRemoval: true,
        useWaste: true,
        useOcr: false,
        ocrProvider: 0,
        digitalCertifiedExpense: false,
        // for DPAE
        useDpae: false,
        contractHourlyRatePrecision: DEFAULT_HOUR_RATE_PRECISION,
        hasCncEcoRequirements: false,
        mainProductionCountry: 0,
        coProductionCountries: null,
        finalDataAuditDate: null,
        projectedDataAuditDate: null
      },
      originalProject: {
        licenseID: 0,
        titre: '',
        production: '',
        realisateur: '',
        timeZone: 'CET',
        language: 0,
        currency: 0,
        distanceUnit: 0,
        projectType: 0,
        productionMethod: [],
        mainBroadcastMode: 0,
        mainBroadcastMode: 0,
        productionType: 0,
        filmLength: 0,
        numEpisode: 0,
        shootingFormat: 0,
        carbonModel: 1,
        greenReporting: 1,
        useOvertime: true,
        useOvt1: true,
        useOvt2: true,
        useHomeToWorkTime: true,
        useTransport: true,
        useLunchPerDiem: true,
        useHotelPerDiem: true,
        useTimesheet: true,
        useExpense: true,
        usePurchaseOrder: true,
        useDocument: true,
        useCallSheet: true,
        useAccommodation: true,
        useTipOfDay: true,
        useEntryForCrewTimesheet: true,
        useEntryForCrewPo: true,
        useEntryForCrewExpenses: true,
        useEntryForCrew: true,
        useGreenSupplier: true,
        useTask: true,
        usePlanning: true,
        useClient: true,
        useBudget: true,
        useNightHours: true,
        useTooEarlyHours: true,
        useSixthDay: true,
        useLunchTime: true,
        useStageDay: true,
        useBeforeCallTime: true,
        useWeeklyOvt: true,
        useWeeklyOvt1: true,
        useWeeklyOvt2: true,
        useSeventhDay: true,
        useSundayRate: true,
        picture: '',
        songMusic: '',
        coProducers: '',
        invoiceDetails: '',
        addressId: 0,
        startDate: '2021-10-13T00:00:00Z',
        endDate: '2021-10-13T00:00:00Z',
        customerId: '',
        numberOfUser: 10,
        supportLevel: 1,
        // vatPercent: 0,
        useForCrewInvoice: false,
        largeAccount: false,
        largeAccountPaid: false,
        lastOrderFormat: '',
        lastOfferFormat: '',
        lastInvoiceFormat: '',
        lastInvoiceNumber: 0,
        lastOfferNumber: 0,
        lastOrderNumber: 0,
        userName: '',
        hodName: '',
        managerName: '',
        shootingStartDate: null,
        wrapStartDate: null,
        useExpenseTravel: true,
        useExpenseTicket: true,
        useExpenseInvoice: true,
        reference: '',
        payrollInterface: 0,
        allowTSEntryOutsideContract: false,
        allowPOEntryOutsideContract: false,
        allowExpenseEntryOutsideContract: false,
        hideDealMemoInfo: false,
        mandatoryCategoryExpense: false,
        analyticPeriodType: 0,
        ccPersonalAccessToken: '',
        ccShareReporting: '',
        // useKlippaOcr: false,
        lastPoFormat: '',
        lastPoNumber: 0,
        regionalSetting: 0,
        useOcr: false,
        ocrProvider: 0,
        digitalCertifiedExpense: false,
        // for DPAE
        useDpae: false,
        contractHourlyRatePrecision: DEFAULT_HOUR_RATE_PRECISION,
        mainProductionCountry: 0,
        coProductionCountries: null
      },
      errors: [],
      show: true,
      selectedRadioOffer: true,
      selectedRadioOrder: true,
      selectedRadioInvoice: true,
      selectedRadioPo: true,
      offerInitialLength: 1,
      offerInitialText: '',
      orderInitialLength: 1,
      orderInitialText: '',
      invoiceInitialLength: 1,
      poInitialLength: 1,
      invoiceInitialText: '',
      poInitialText: '',
      selectedRadioOfferYear: 0,
      selectedRadioOrderYear: 0,
      selectedRadioInvoiceYear: 0,
      selectedRadioPoYear: 0,
      defaultFormat: `%01d`,
      isStartMobilePwaCaptureLoading: false,
      isSupplierUpdate: false,
      masks: {
        input: 'DD/MM/YYYY'
      },
      attrs: [
        {
          highlight: {
            fillMode: 'light'
          },
          dates: new Date()
        }
      ],
      allowTSEntryOutsideContract: false,
      allowPOEntryOutsideContract: false,
      allowExpenseEntryOutsideContract: false,
      itterationAnalyticSelected: 1,
      finalDataAuditDate: null,
      projectedDataAuditDate: null,
      hasCncEcoRequirements: false,
      selectedSupplier: null,
      legalEntities: [],
      showHolidaysModal: false,
      disableCarbonModel: false
    };
  },
  computed: {
    ocrProviderOptions() {
      return this.FormMenu(11030);
    },
    isDev() {
      return store.isDev();
    },
    diffDatesFilm() {
      const dates1 = moment(this.project.shootingStartDate);
      const dates2 = moment(this.project.wrapStartDate);
      const diffInDays = dates2.diff(dates1, 'days');
      if (diffInDays) {
        return diffInDays + 1;
      } else {
        return 0;
      }
    },
    diffDates() {
      const date1 = moment(this.project.startDate);
      const date2 = moment(this.project.endDate);

      // Calculate the difference in days using the 'diff' method
      const diffInDays = date2.diff(date1, 'days');
      return diffInDays + 1;
    },
    analyticPeriodOptions() {
      let menues = this.FormMenu(10005);
      let result = [];

      if (this.itterationAnalyticSelected === 2) {
        result = menues.filter((option) => ![0, 4].includes(option.value));
      }

      if (this.itterationAnalyticSelected === 3) {
        result = menues.filter((option) => option.value === 4);
      }

      return result;
    },
    itterationAnalyticOptions() {
      return [
        { text: '1', value: 1 },
        { text: '2', value: 2 },
        { text: '3', value: 3 }
      ];
    },
    allowEntryOutsideContract: {
      get() {
        return this.project.allowTSEntryOutsideContract || this.project.allowPOEntryOutsideContract || this.project.allowExpenseEntryOutsideContract;
      },
      set(newVal) {
        if (newVal === true) {
          if (!this.project.allowTSEntryOutsideContract && !this.project.allowPOEntryOutsideContract && !this.project.allowExpenseEntryOutsideContract) {
            this.project.allowTSEntryOutsideContract = newVal;
            this.project.allowPOEntryOutsideContract = newVal;
            this.project.allowExpenseEntryOutsideContract = newVal;
          }
        } else {
          this.project.allowTSEntryOutsideContract = newVal;
          this.project.allowPOEntryOutsideContract = newVal;
          this.project.allowExpenseEntryOutsideContract = newVal;
        }
      }
    },
    displayLargeAccount() {
      if (this.project.projectType === 1) {
        return true;
      } else {
        return false;
      }
    },
    disableLargeAccount() {
      if (this.project.projectType === 1 && store.isDev()) {
        return false;
      } else {
        return true;
      }
    },
    imageName() {
      if (this.project.picture && this.project.picture.length > 0) {
        const strImg = process.env.VUE_APP_GQL + '/images/' + this.project.picture;
        //  console.log("pictPath:",strImg);
        return strImg;
      } else {
        return 'img/brand/M.JPG';
      }
    },
    optionsForLanguages() {
      let menus = this.FormMenu(1);

      menus.sort((a, b) => {
        if (noTilde(a.text.trim()).toLowerCase() < noTilde(b.text.trim()).toLowerCase()) {
          return -1;
        }
        if (noTilde(a.text.trim()).toLowerCase() > noTilde(b.text.trim()).toLowerCase()) {
          return 1;
        }

        return 0;
      });

      return menus;
    },
    optionForFormat() {
      return this.FormMenu(1355);
    },
    optionForType() {
      let type = [
        {
          label: this.FormMSG(1000, 'Film'),
          options: this.FormMenu(1350)
        },
        {
          label: this.FormMSG(1001, 'TV/ Audiovisual'),
          options: this.FormMenu(1351)
        },
        {
          label: this.FormMSG(1002, 'Shows'),
          options: this.FormMenu(1352)
        },
        {
          label: this.FormMSG(1003, 'Publicity'),
          options: this.FormMenu(1353)
        },
        {
          label: this.FormMSG(1005, 'Video'),
          options: this.FormMenu(11040)
        },
        {
          label: this.FormMSG(1004, 'Other'),
          options: this.FormMenu(1354)
        }
      ];
      return type;
    },
    optionForMethod() {
      const optionForMethod = this.FormMenu(11041);

      if (!Array.isArray(optionForMethod)) {
        return [];
      }

      return optionForMethod.filter((option) => option && option.value !== undefined);
    },
    valueForProdMethod() {
      let newProdListStr = [];
      newProdListStr = this.project.productionMethod.split(',');
      newProdList = newProdListStr.map((val) => {
        this.FormMenu(11041)[val];
      });

      return newProdList;
    },
    optionForBroadcastMode() {
      return this.FormMenu(11042);
    },

    showGoBack() {
      if (
        this.$route.name == 'AddProjectForLicenseFromDev' ||
        this.$route.name == 'UpdateProjectForLicenseFromDev' ||
        this.$route.name == 'UpdateProjectFromProjects'
      ) {
        return true;
      } else {
        return false;
      }
    },
    showAddPme() {
      if (isNil(this.$route.name) && store.isPme()) {
        return true;
      }
      return false;
    },
    mapCurrencies() {
      return this.FormMenu(5);
    },
    mapTgsProjectType() {
      return this.FormMenu(1025);
    },
    mapCarbonModels() {
      let allMenus = this.FormMenu(7);
      const first = allMenus[0];
      let menus = allMenus.filter((menu) => menu.value !== 0 && menu.value !== 4 && menu.value !== 5 && menu.value !== 6);

      menus.sort((a, b) => {
        if (noTilde(a.text).toLowerCase() < noTilde(b.text).toLowerCase()) {
          return -1;
        }
        if (noTilde(a.text).toLowerCase() > noTilde(b.text).toLowerCase()) {
          return 1;
        }

        return 0;
      });

      allMenus = [];
      allMenus.push(first);
      for (let menu of menus) {
        menu.text = capitalize(menu.text);
        if (menu.value === 1) {
          menu.disabled = true;
        }

        allMenus.push(menu);
      }

      return allMenus;
    },
    mapGreenReporting() {
      let allMenus = this.FormMenu(1130);
      const first = allMenus[0];
      let menus = allMenus.filter((menu) => menu.value !== 0);

      menus.sort((a, b) => {
        if (noTilde(a.text).toLowerCase() < noTilde(b.text).toLowerCase()) {
          return -1;
        }
        if (noTilde(a.text).toLowerCase() > noTilde(b.text).toLowerCase()) {
          return 1;
        }

        return 0;
      });

      allMenus = [];
      allMenus.push(first);
      for (let menu of menus) {
        menu.text = capitalize(menu.text);
        allMenus.push(menu);
      }

      return allMenus;
    },
    disableSave() {
      return !this.projectIsModified();
    },
    radioOrderOptions() {
      return [
        { text: this.FormMSG(44, 'Use default format'), value: true },
        { text: this.FormMSG(45, 'Use my custom format'), value: false }
      ];
    },
    radioOfferOptions() {
      return [
        { text: this.FormMSG(44, 'Use default format'), value: true },
        { text: this.FormMSG(45, 'Use my custom format'), value: false }
      ];
    },
    radioInvoiceOptions() {
      return [
        { text: this.FormMSG(44, 'Use default format'), value: true },
        { text: this.FormMSG(45, 'Use my custom format'), value: false }
      ];
    },
    radioOfferYearOptions() {
      return [
        { text: this.FormMSG(46, 'YYYY'), value: 2 },
        { text: this.FormMSG(47, 'YY'), value: 1 },
        { text: this.FormMSG(59, 'None'), value: 0 }
      ];
    },
    radioOrderYearOptions() {
      return [
        { text: this.FormMSG(46, 'YYYY'), value: 2 },
        { text: this.FormMSG(47, 'YY'), value: 1 },
        { text: this.FormMSG(59, 'None'), value: 0 }
      ];
    },
    radioInvoiceYearOptions() {
      return [
        { text: this.FormMSG(46, 'YYYY'), value: 2 },
        { text: this.FormMSG(47, 'YY'), value: 1 },
        { text: this.FormMSG(59, 'None'), value: 0 }
      ];
    },
    renderOfferFormat() {
      const incNumber = this.project.lastOfferNumber.toString();
      let formatYear = '';
      let year = '';

      if (!this.selectedRadioOffer) {
        if (this.selectedRadioOfferYear === 2) {
          formatYear = 'YYYY';
        } else if (this.selectedRadioOfferYear === 1) {
          formatYear = 'YY';
        }

        if (formatYear !== '') {
          year = new moment(new Date()).format(formatYear);
        }
      }

      return !this.selectedRadioOffer ? this.offerInitialText.toUpperCase() + year + incNumber.padStart(this.offerInitialLength, '0') : incNumber;
    },
    renderOrderFormat() {
      const incNumber = this.project.lastOrderNumber.toString();
      let formatYear = '';
      let year = '';

      if (!this.selectedRadioOrder) {
        if (this.selectedRadioOrderYear === 2) {
          formatYear = 'YYYY';
        } else if (this.selectedRadioOrderYear === 1) {
          formatYear = 'YY';
        }

        if (formatYear !== '') {
          year = new moment(new Date()).format(formatYear);
        }
      }

      return !this.selectedRadioOrder ? this.orderInitialText.toUpperCase() + year + incNumber.padStart(this.orderInitialLength, '0') : incNumber;
    },
    renderInvoiceFormat() {
      const incNumber = this.project.lastInvoiceNumber.toString();
      let formatYear = '';
      let year = '';

      if (!this.selectedRadioInvoice) {
        if (this.selectedRadioInvoiceYear === 2) {
          formatYear = 'YYYY';
        } else if (this.selectedRadioInvoiceYear === 1) {
          formatYear = 'YY';
        }
        if (formatYear !== '') {
          year = new moment(new Date()).format(formatYear);
        }
      }

      return !this.selectedRadioInvoice ? this.invoiceInitialText.toUpperCase() + year + incNumber.padStart(this.invoiceInitialLength, '0') : incNumber;
    },
    renderPoFormat() {
      const incNumber = this.project.lastPoNumber.toString();
      let formatYear = '';
      let year = '';

      if (!this.selectedRadioPo) {
        if (this.selectedRadioPoYear === 2) {
          formatYear = 'YYYY';
        } else if (this.selectedRadioPoYear === 1) {
          formatYear = 'YY';
        }
        if (formatYear !== '') {
          year = new moment(new Date()).format(formatYear);
        }
      }

      return !this.selectedRadioPo ? this.poInitialText.toUpperCase() + year + incNumber.padStart(this.poInitialLength, '0') : incNumber;
    },
    mapDistacneUnits() {
      return this.FormMenu(1330);
    },
    labelLegalEntity() {
      if (this.isFilmSingle) {
        return this.FormMSG(454, 'Employer legal entity');
      } else {
        return this.FormMSG(455, 'Legal entity details');
      }
    },
    mapPayrollInterface() {
      return this.FormMenu(1335);
    },
    regionalSettingOptions() {
      let menus = this.FormMenu(11023);

      menus.sort((a, b) => {
        if (a.text < b.text) {
          return -1;
        }
        if (a.text > b.text) {
          return 1;
        }

        return 0;
      });

      return menus;
    }
  },
  watch: {
    canUpdate: 'executeSubmitForm',
    canCreate: 'executeCreateSubmitForm',
    Project: {
      handler: function (n) {
        if (!isNil(n)) {
          this.disableSave;
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.$nextTick(async function () {
      let projectID = parseInt(this.projectFormId);
      if (!isNil(this.$route.name) && (this.$route.name == 'AddProjectForLicenseFromDev' || this.isCreateWithModal)) {
        // do not load project adding a new one
        this.enableProjectTypeChoice = true;
        projectID = -1;
        this.project.startDate = new Date().toJSON(); // .slice(0, 10);

        if (this.isCreateWithModal) {
          this.project.projectType = 4;
          this.project.licenseID = this.licenseId;
        }

        let endDate = new Date();
        endDate.setDate(endDate.getDate() + 90);
        this.project.endDate = endDate.toJSON();
        this.stSubscriptionEndDate = '2050-12-31T00:00:00Z';
        this.stUnpaidTrigger = '2050-12-31T00:00:00Z';
        this.stWaitForPaiement = '2050-12-31T00:00:00Z';
        this.stBlockingTime = '2050-12-31T00:00:00Z';
      } else if (!isNil(this.$route.name) && this.$route.name === 'UpdateProjectForLicenseFromDev') {
        // console.log("in submit8", this.$route.params.projectId);
        projectID = parseInt(this.$route.params.projectId);
      } else if (!isNil(this.$route.name) && this.$route.name === 'UpdateProjectFromProjects') {
        // console.log("in submit9", this.$route.params.projectId);
        projectID = parseInt(this.$route.params.projectId);
      } else if (!isNil(this.$route.params) && !isNil(this.$route.params.id) && +this.$route.params.id === 0) {
        // console.log("in submit19", this.$route.params.projectId);
        projectID = parseInt(store.projectID(), 10);
      }

      //console.log("projectID:", projectID)
      if (projectID >= 0) {
        this.project = await getProject(projectID);

        /**
         * @TODO
         * let multiselect
         */
        this.selectedSupplier = this.project.legalEntities.length === 0 ? null : this.project.legalEntities[0].id;

        // console.log({ project: this.project });
        this.originalProject = { ...this.project };
        this.emitBusProject();
        this.project.shootingStartDate = !isNil(this.project.shootingStartDate) ? new Date(this.project.shootingStartDate) : '';
        this.project.wrapStartDate = !isNil(this.project.wrapStartDate) ? new Date(this.project.wrapStartDate) : '';

        // console.log("Project => ",this.project);
        if (this.project.projectType === 0 || this.project.projectType === 1 || this.project.projectType === 4) {
          this.setLabelFormatValue();
          // console.log({ Project: this.project })
          // console.log({ OriginalProject: this.originalProject })
        }

        if (this.project.useExpense && isNil(this.project.useExpenseTravel) && isNil(this.project.useExpenseTicket) && isNil(this.project.useExpenseInvoice)) {
          this.project = {
            useExpenseTravel: true,
            useExpenseTicket: true,
            useExpenseInvoice: true,
            ...this.project
          };
        }

        if (this.project.projectedDataAuditDate === '0001-01-01T00:00:00Z' || this.project.finalDataAuditDate === ' 0001-01-01T00:00:00Z') {
          const today = new Date();
          const plus30Days = new Date();
          plus30Days.setDate(today.getDate() + 30);

          this.project = {
            ...this.project,
            projectedDataAuditDate: today.toISOString(),
            finalDataAuditDate: plus30Days.toISOString()
          };
        }

        if (this.project.analyticPeriodType === 0) {
          this.itterationAnalyticSelected = 1;
        } else if ([1, 2, 3].includes(this.project.analyticPeriodType)) {
          this.itterationAnalyticSelected = 2;
        } else if (this.project.analyticPeriodType === 4) {
          this.itterationAnalyticSelected = 3;
        }
        this.project.productionMethod = this.productionMethodToList(this.project.productionMethod);
      }
    });
  },
  methods: {
    async replicateTemplateProject() {
      this.clickedReplicateBtn = true;
      this.replicatingInProgress = true;
      const templateProject = await getProject(-1); // -1: stand for the default payroll project template saved in the back config.
      if (templateProject) {
        this.project = {
          ...templateProject,
          licenseID: parseInt(this.$route.params.licenseId),
          productionMethod: this.productionMethodToList(templateProject.productionMethod),
          titre: this.project.titre ? this.project.titre : '',
          production: this.project.production ? this.project.production : ''
        };
        this.createToastForMobile(
          this.FormMSG(252, 'Information'),
          this.FormMSG(7446, 'Copy from template successfully done, please verify your data before saving...'),
          '',
          'success'
        );
      } else {
        this.createToastForMobile(
          this.FormMSG(252, 'Information'),
          this.FormMSG(7447, 'Some issues occured when attempting to copy template data.'),
          '',
          'error'
        );
      }
      this.replicatingInProgress = false;
    },
    handleConfirmReplicateAction(isConfirm) {
      this.saveProject(isConfirm);
      this.showReplicateInfoDialog = false;
    },
    handleMainCountryChange(country, field) {
      this.project[field] = country.key.value;
    },
    handleCountryChange(country, field) {
      this.project[field] = country.key;
    },
    onDpaeAddressChanged(addressData, field) {
      // const projectDpaeAddress = addressData.route || addressData.place.name + ', ' + addressData.country;
      if (field === 'address-1') {
        this.project.urssafLocalAddressId = addressData.id;
      } else {
        this.project.supplementaryPensionFundAddressId = addressData.id;
      }
      // setTimeout(() => {
      // 	console.log(this.project.urssafLocalAddress);
      // }, 3000);
    },
    onDpaeAddressDeleted(field) {
      if (field === 'address-1') {
        this.project.urssafLocalAddressId = 0;
      } else {
        this.project.supplementaryPensionFundAddressId = 0;
      }
    },
    productionMethodToList(productionMethod) {
      productionMethod += '';
      // productionMethod = productionMethod.length > 0 ? productionMethod.split(',').map((val) => this.FormMenu(11041)[val-1]) : [];
      let optionForMenu = this.FormMenu(11041);
      productionMethod = productionMethod.split(',').map((element) => {
        const finding = optionForMenu.find((item) => parseInt(item.value) == parseInt(element));
        if (finding) return finding;
      });
      return productionMethod;
    },
    handleChangeUseOcr(value) {
      if (!value) {
        this.project.ocrProvider = 0;
      }
    },
    handleGreen(event, pos) {
      if (pos == 0) {
        this.project.useCarbonTemplate = event;
        this.project.useGreenTable = event;
        this.project.useReporting = event;
        this.project.useCarbonRemoval = event;
        this.project.useWaste = event;
        this.project.useTipOfDay = event;
      } else {
        if (
          !this.project.useCarbonTemplate &&
          !this.project.useGreenTable &&
          !this.project.useReporting &&
          !this.project.useCarbonRemoval &&
          !this.project.useWaste &&
          !this.project.useTipOfDay
        ) {
          this.project.useGreen = false;
        } else {
          this.project.useGreen = true;
        }
      }
    },
    handleFinance(event, pos) {
      if (pos === 0) {
        this.project.useGreenSupplier = event;
        this.project.usePurchaseOrder = event;
        this.project.useExpense = event;
        this.project.useTimesheet = event;
        this.project.useTimesheetPlanning = event;
        this.project.useBudget = event;
        this.project.useExpenseInvoice = event;
        this.project.digitalCertifiedExpense = event;
        this.handleControlExpense(event, 0);
      } else {
        if (pos === 2) {
          this.handleControlExpense(event, 0);
        }

        if (
          !this.project.useGreenSupplier &&
          !this.project.usePurchaseOrder &&
          !this.project.useExpense &&
          !this.project.useTimesheet &&
          !this.project.useTimesheetPlanning &&
          !this.project.useBudget &&
          !this.project.useExpenseInvoice &&
          !this.project.digitalCertifiedExpense
        ) {
          this.project.useFinance = false;
        } else {
          this.project.useFinance = true;
        }
      }
    },
    handleUseProd(event, pos) {
      if (pos == 0) {
        this.project.useTransport = event;
        this.project.useDocument = event;
        this.project.useCallSheet = event;
        this.project.useAccommodation = event;
        this.project.useContacts = event;
        this.project.useCrewSetup = event;
        this.project.useLocations = event;
        this.project.useExport = event;
        this.project.useImport = event;
      } else {
        if (
          !this.project.useTransport &&
          !this.project.useDocument &&
          !this.project.useCallSheet &&
          !this.project.useAccommodation &&
          !this.project.useContacts &&
          !this.project.useCrewSetup &&
          !this.project.useLocations &&
          !this.project.useExport &&
          !this.project.useImport
        ) {
          this.project.useProduction = false;
        } else {
          this.project.useProduction = true;
        }
      }
    },
    handleChangeItterationAnalytic(payload) {
      if (payload === 1) {
        this.project.analyticPeriodType = 0;
      } else if (payload === 2) {
        this.project.analyticPeriodType = 1;
      } else if (payload === 3) {
        this.project.analyticPeriodType = 4;
      }
    },
    projectIsModified() {
      // compare originalProject and Project to activate save button
      if (JSON.stringify(this.project) === JSON.stringify(this.originalProject)) {
        return false;
      }
      return true;
    },
    async startMobilePwaCapture() {
      store.state.capturedImage = '';
      store.state.imageCropped = '';

      const photo = await Camera.getPhoto({
        resultType: CameraResultType.Uri,
        allowEditing: true,
        quality: 100
      });

      const blob = await fetch(photo.webPath).then((r) => r.blob());
      let formData = new FormData();
      formData.append('uploadimage', blob);

      try {
        const savedImg = await this.$axios.$post('upload', formData, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
            'content-type': 'multipart/form-data'
          }
        });
        this.handleImgsTaken([savedImg]);
      } catch (e) {
        console.error({ e });
      }
      // this.isStartMobilePwaCaptureLoading = false
    },
    /**
     *
     * To send the Project variable by event
     */
    emitBusProject() {
      this.$bus.$emit('bus:projectevent', this.project);
    },
    async executeSubmitForm() {
      if (this.canUpdate && this.canUpdate === true) {
        await this.submitForm();
        this.$emit('updatefinishevent');
      }
    },
    async executeCreateSubmitForm() {
      if (this.canCreate && this.canCreate === true) {
        await this.submitForm();
        this.$emit('createfinishevent', this.originalProject);
      }
    },
    handleAdminOwnerChange(supplier) {
      // console.log({ supplier });
      this.isSupplierUpdate = false;

      if (isNil(supplier)) return;
      this.selectedSupplier = +supplier.id;

      // @TODO review when we must to select one or more suppliers
      this.legalEntities = [];
      this.legalEntities.push(+supplier.id);

      this.isSupplierUpdate = true;
    },
    updateStartDate: function ($event) {
      if (this.project.startDate.startsWith('T')) {
        this.project.startDate = $event + this.project.startDate;
      } else {
        this.project.startDate = $event + this.project.startDate.substring(10);
      }
      // console.log("this.startDate:",this.project.startDate);
    },
    updateEndDate: function ($event) {
      if (this.project.endDate.startsWith('T')) {
        this.project.endDate = $event + this.project.endDate;
      } else {
        this.project.endDate = $event + this.project.endDate.substring(10);
      }
    },
    addPme() {
      this.newPmeModal = true;
    },
    async newPmeConfirmed() {
      let ProjectId = 0;
      if (!isNil(this.project.id)) {
        ProjectId = parseInt(this.project.id);
      }

      let Filter = {};
      Filter.allData = false;
      Filter.allConfig = this.copyPmeConfig;
      const PmeName = this.newPmeName;
      if (PmeName.length == 0) {
        alert(this.FormMSG(131, 'New entity name is empty!'));
        return;
      }
      this.isLoading = true;
      await newSmeProject(ProjectId, PmeName, Filter);
      this.isLoading = false;
      window.location.reload(true); // to force update project list in myproject
    },
    viewUsersLink(id) {
      return `/projects/${id.toString()}/users`;
    },
    viewUsers() {
      //console.log("viewUsers link:");
      const viewProjectUsersLink = this.viewUsersLink(this.project.id);
      //console.log("viewUsers link:", viewProjectUsersLink);
      this.$router.push({
        path: viewProjectUsersLink
      });
    },
    addSaveLabel() {
      if (this.$route.name == 'AddProjectForLicenseFromDev') {
        return this.FormMSG(11, 'Add project');
      } else {
        return this.FormMSG(12, 'Save');
      }
    },
    goBack() {
      this.$router.go(-1);
      // this.$router.replace({path: '/users'})
    },
    async saveProject(isConfirmReplicate = false) {
      this.isLoading = true;
      let addRequest = false;
      let licenseId = null;
      if (!isNil(this.$route.name) && (this.$route.name == 'AddProjectForLicenseFromDev' || this.isCreateWithModal)) {
        // console.log("in submit3", this.$route.params.licenseId);
        addRequest = true;
        licenseId = parseInt(this.$route.params.licenseId);
        // console.log("in ProjectFor addproject for licenseId:", licenseId);
        //}UpdateProjectForLicenseFromDev
      } else if (!isNil(this.$route.name) && this.$route.name == 'UpdateProjectForLicenseFromDev') {
        // console.log("in submit6", this.$route.params.licenseId);
        licenseId = parseInt(this.$route.params.licenseId);
        // console.log("in ProjectFor updproject for licenseId:", licenseId);
        //}UpdateProjectForLicenseFromDev
      }

      // Manage shootingStartDate and wrapStartDate
      this.manageStartDateWrapShootByAnalyticPeriod();

      let newProject = {};
      let projectId = 0;
      if (!isNil(this.project.id)) {
        projectId = parseInt(this.project.id);
      }

      const isObject = (obj) => {
        return typeof obj === 'object' && obj !== null && !Array.isArray(obj);
      };

      newProject.id = 0;
      newProject.titre = this.project.titre;
      newProject.production = this.project.production;
      newProject.realisateur = this.project.realisateur;
      newProject.timeZone = this.project.timeZone;
      newProject.licenseID = parseInt(this.project.licenseID);
      newProject.currency = parseInt(this.project.currency);
      newProject.distanceUnit = parseInt(this.project.distanceUnit);
      newProject.projectType = parseInt(this.project.projectType);
      if (!(this.project.productionMethod.length > 0 && isObject(this.project.productionMethod[0]))) {
        newProject.productionMethod = this.project.productionMethod.join(',');
      }
      newProject.mainBroadcastMode = this.project.mainBroadcastMode;
      newProject.carbonModel = parseInt(this.project.carbonModel);
      newProject.greenReporting = parseInt(this.project.greenReporting);
      newProject.useOvertime = this.project.useOvertime;
      newProject.useOvt1 = this.project.useOvt1;
      newProject.useOvt2 = this.project.useOvt2;
      newProject.useHomeToWorkTime = this.project.useHomeToWorkTime;
      newProject.useTransport = this.project.useTransport;
      newProject.useLunchPerDiem = this.project.useLunchPerDiem;
      newProject.useHotelPerDiem = this.project.useHotelPerDiem;
      newProject.useTimesheet = this.project.useTimesheet;
      newProject.useExpense = this.project.useExpense;
      newProject.usePurchaseOrder = this.project.usePurchaseOrder;
      newProject.useDocument = this.project.useDocument;
      newProject.useCallSheet = this.project.useCallSheet;
      newProject.useAccommodation = this.project.useAccommodation;
      newProject.useTipOfDay = this.project.useTipOfDay;
      newProject.useGreenSupplier = this.project.useGreenSupplier;
      newProject.useTask = this.project.useTask;
      newProject.usePlanning = this.project.usePlanning;
      newProject.useClient = this.project.useClient;
      newProject.useBudget = this.project.useBudget;
      newProject.useNightHours = this.project.useNightHours;
      newProject.useTooEarlyHours = this.project.useTooEarlyHours;
      newProject.useSixthDay = this.project.useSixthDay;
      newProject.useLunchTime = this.project.useLunchTime;
      newProject.hideSalaryInfo = this.project.hideSalaryInfo;
      newProject.hideDealMemoInfo = this.project.hideDealMemoInfo;
      newProject.mandatoryExpenseReceipt = this.project.mandatoryExpenseReceipt;
      newProject.mandatoryInvoiceReceipt = this.project.mandatoryInvoiceReceipt;
      newProject.mandatoryCategoryExpense = this.project.mandatoryCategoryExpense;
      newProject.useStageDay = this.project.useStageDay;
      newProject.language = parseInt(this.project.language);
      newProject.picture = this.project.picture;
      newProject.coProducers = this.project.coProducers;
      newProject.songMusic = this.project.songMusic;
      newProject.invoiceDetails = this.project.invoiceDetails;
      newProject.useProduction = this.project.useProduction;
      newProject.useContacts = this.project.useContacts;
      newProject.useCrewSetup = this.project.useCrewSetup;
      newProject.useLocations = this.project.useLocations;
      newProject.useExport = this.project.useExport;
      newProject.useImport = this.project.useImport;
      newProject.useFinance = this.project.useFinance;
      newProject.useTimesheetPlanning = this.project.useTimesheetPlanning;
      newProject.useGreen = this.project.useGreen;
      newProject.useCarbonTemplate = this.project.useCarbonTemplate;
      newProject.useGreenTable = this.project.useGreenTable;
      newProject.useReporting = this.project.useReporting;
      newProject.useCarbonRemoval = this.project.useCarbonRemoval;
      newProject.useWaste = this.project.useWaste;
      newProject.startDate = this.project.startDate;
      newProject.endDate = this.project.endDate;
      newProject.customerId = this.project.customerId;
      // newProject.vatPercent = parseFloat(this.project.vatPercent); moved inside supplier modal
      newProject.numberOfUser = parseInt(this.project.numberOfUser);
      newProject.supportLevel = parseInt(this.project.supportLevel);
      newProject.useForCrewInvoice = this.project.useForCrewInvoice;
      newProject.useEntryForCrewInvoice = this.project.useEntryForCrewInvoice;
      newProject.largeAccount = this.project.largeAccount;
      newProject.largeAccountPaid = this.project.largeAccountPaid;
      newProject.lastOfferNumber = isNaN(parseInt(this.project.lastOfferNumber, 10)) ? 0 : parseInt(this.project.lastOfferNumber, 10);
      newProject.lastOrderNumber = isNaN(parseInt(this.project.lastOrderNumber, 10)) ? 0 : parseInt(this.project.lastOrderNumber, 10);
      newProject.lastInvoiceNumber = isNaN(parseInt(this.project.lastInvoiceNumber, 10)) ? 0 : parseInt(this.project.lastInvoiceNumber, 10);
      newProject.lastPoNumber = isNaN(parseInt(this.project.lastPoNumber, 10)) ? 0 : parseInt(this.project.lastPoNumber, 10);
      newProject.userName = this.project.userName;
      newProject.hodName = this.project.hodName;
      newProject.managerName = this.project.managerName;
      newProject.shootingStartDate = !isNil(this.project.shootingStartDate)
        ? moment(this.project.shootingStartDate).format('YYYY-MM-DD') + 'T00:00:00Z'
        : '0001-01-01T00:00:00Z';
      newProject.wrapStartDate = !isNil(this.project.wrapStartDate)
        ? moment(this.project.wrapStartDate).format('YYYY-MM-DD') + 'T00:00:00Z'
        : '0001-01-01T00:00:00Z';
      newProject.useBeforeCallTime = this.project.useBeforeCallTime;
      newProject.useWeeklyOvt = this.project.useWeeklyOvt;
      newProject.useWeeklyOvt1 = this.project.useWeeklyOvt1;
      newProject.useWeeklyOvt2 = this.project.useWeeklyOvt2;
      newProject.useSeventhDay = this.project.useSeventhDay;
      newProject.useSundayRate = this.project.useSundayRate;
      newProject.useDinnerPerDiem = this.project.useDinnerPerDiem;
      newProject.useAbroadPerDiem = this.project.useAbroadPerDiem;
      newProject.budgetLocked = this.project.budgetLocked;
      // newProject.useExpenseTravel = this.project.useExpenseTravel;
      // newProject.useExpenseTicket = this.project.useExpenseTicket;
      // newProject.useExpenseInvoice = this.project.useExpenseInvoice;
      newProject.useExpenseTravel = this.project.useExpenseTravel;
      newProject.useExpenseTicket = this.project.useExpenseTicket;
      newProject.useExpenseInvoice = this.project.useExpenseInvoice;
      newProject.reference = this.project.reference;
      newProject.payrollInterface = this.project.payrollInterface;
      newProject.useEntryForCrewExpenses = this.project.useEntryForCrewExpenses;
      newProject.useEntryForCrewPo = this.project.useEntryForCrewPo;
      newProject.useEntryForCrewTimesheet = this.project.useEntryForCrewTimesheet;
      newProject.useEntryForCrewInvoice = this.project.useEntryForCrewInvoice;
      newProject.useEntryForCrew = this.project.useEntryForCrew;
      newProject.allowTSEntryOutsideContract = this.project.allowTSEntryOutsideContract;
      newProject.allowPOEntryOutsideContract = this.project.allowPOEntryOutsideContract;
      newProject.allowExpenseEntryOutsideContract = this.project.allowExpenseEntryOutsideContract;
      newProject.analyticPeriodType = this.project.analyticPeriodType;
      newProject.shootingFormat = this.project.shootingFormat;
      newProject.productionType = this.project.productionType;
      newProject.filmLength = parseInt(this.project.filmLength, 10);
      newProject.numEpisode = parseInt(this.project.numEpisode, 10);
      newProject.ccPersonalAccessToken = this.project.ccPersonalAccessToken;
      newProject.ccShareReporting = this.project.ccShareReporting;
      newProject.useOcr = this.project.useOcr;
      newProject.ocrProvider = this.project.ocrProvider;
      newProject.digitalCertifiedExpense = this.project.digitalCertifiedExpense;

      // newProject.useKlippaOcr = this.project.useKlippaOcr;
      newProject.maxExpenseItemsPerSheet = +this.project.maxExpenseItemsPerSheet;
      newProject.regionalSetting = +this.project.regionalSetting;

      // needed for DPAE
      newProject.useDpae = this.project.useDpae;

      // needed for contract hourly rate precision
      newProject.contractHourlyRatePrecision = +this.project.contractHourlyRatePrecision;

      newProject.mainProductionCountry = this.project.mainProductionCountry;

      if (typeof this.project.coProductionCountries === 'string') {
        newProject.coProductionCountries = this.project.coProductionCountries;
      } else {
        newProject.coProductionCountries =
          this.project.coProductionCountries && this.project.coProductionCountries.length > 0
            ? this.project.coProductionCountries.map((item) => item.value).join(',')
            : null;
      }

      newProject.finalDataAuditDate = this.project.finalDataAuditDate;
      newProject.projectedDataAuditDate = this.project.projectedDataAuditDate;
      newProject.hasCncEcoRequirements = this.project.hasCncEcoRequirements;

      newProject = this.getNewFormatValue(newProject);

      if (!isNil(licenseId)) {
        newProject.licenseID = licenseId;
      }
      if (addRequest) {
        if (this.isCreateWithModal) {
          newProject.licenseID = parseInt(store.getCurrentProjectConfig().licenseID);
          newProject.endDate = '2099-12-30T00:00:00Z';
        }
        if (store.isFilmSingleUser()) {
          this.project = await addProject(newProject, parseInt(store.getCurrentProjectConfig().id), this.legalEntities, isConfirmReplicate).finally(() => {
            this.isLoading = false;
          });
          // this.successSend(this.FormMSG(156, 'Added project successfully'));
        } else {
          this.project = await addProject(newProject, 0, this.legalEntities, isConfirmReplicate).finally(() => {
            this.isLoading = false;
          });
          // this.successSend(this.FormMSG(156, 'Added project successfully'));
        }

        this.emitBusProject();
        // console.log("in ProjectFor addproject for this.project:", this.project);
      } else {
        await updMyProject(projectId, newProject, this.legalEntities)
          .then(async () => {
            await this.$store.dispatch('refreshToken');
            await store.reloadMyProject();

            this.createToastForMobile(this.FormMSG(252, 'Information'), this.FormMSG(1300, 'Project modification saved successfully'), '', 'success');

            this.emitBusProject();
            newProject.id = projectId;
            store.state.myProject = newProject;
            store.state.noTranslationMenus = {
              userName: newProject.userName,
              hodName: newProject.hodName,
              managerName: newProject.managerName
            };
          })
          .catch((error) => {
            this.createToastForMobile(
              this.FormMSG(24552, 'Error'),
              this.FormMSG(
                1300458,
                `Sorry, cannot perfrom this action, maybe you don't have the right access on this page, please contact your administrator.`
              ),
              '',
              'danger'
            );
            console.error({ error });
          })
          .finally(() => (this.isLoading = false));
      }

      // set originalProject to new or updated project
      this.originalProject = { ...this.project };
      if (this.$route.name == 'AddProjectForLicenseFromDev') {
        localStorage.setItem('license:project-created', 1);
        this.goBack();
      }
    },
    manageStartDateWrapShootByAnalyticPeriod() {
      switch (this.project.analyticPeriodType) {
        case 0:
          this.project.shootingStartDate = this.project.startDate;
          this.project.wrapStartDate = this.project.startDate;
          break;
        case 1:
          this.project.wrapStartDate = this.project.shootingStartDate;
          break;
        case 2:
          this.project.startDate = this.project.shootingStartDate;
          break;
        case 3:
          this.project.shootingStartDate = this.project.wrapStartDate;
          break;
      }
    },
    submitForm: async function () {
      // console.log("in submit");
      this.errors = [];
      // console.log(this.project.productionMethod);
      // e.preventDefault();
      if (this.project.projectType == 0) {
        if (!(this.project.titre && this.project.production && this.project.realisateur && this.project.timeZone)) {
          if (!this.project.titre) {
            this.errors.push(this.FormMSG(53, 'Title required.'));
          }
          if (!this.project.production) {
            this.errors.push(this.FormMSG(54, 'Production required.'));
          }
          if (!this.project.realisateur) {
            this.errors.push(this.FormMSG(55, 'Producer required.'));
          }
          if (!this.project.timeZone) {
            this.errors.push(this.FormMSG(56, 'TimeZone required.'));
          }

          return true;
        }
      } else if (!(this.project.titre && this.project.timeZone)) {
        if (!this.project.titre) {
          this.errors.push(this.FormMSG(53, 'Title required.'));
        }

        if (!this.project.timeZone) {
          this.errors.push(this.FormMSG(56, 'TimeZone required.'));
        }

        return true;
      }
      //console.log("in submit2");
      if (this.clickedReplicateBtn) {
        this.showReplicateInfoDialog = true;
      } else {
        await this.saveProject(false);
      }
    },
    resetForm: function (e) {
      this.errors = [];
      this.project.titre = '';
      this.project.production = '';
      this.project.realisateur = '';
      this.project.timeZone = '';
      this.project.currency = 0;
      this.project.distanceUnit = 0;
      this.project.projectType = 0;
      this.project.productionMethod = [];
      this.project.carbonModel = 0;
      this.project.greenReporting = 0;
      this.project.useOvertime = true;
      this.project.useTooEarlyHours = true;
      this.project.useSixthDay = true;
      this.project.useLunchTime = true;
      this.project.useStageDay = true;
      this.project.useOvt1 = true;
      this.project.useOvt2 = true;
      this.project.useHomeToWorkTime = true;
      this.project.useTransport = true;
      this.project.useLunchPerDiem = true;
      this.project.useHotelPerDiem = true;
      this.project.useTimesheet = true;
      this.project.useExpense = true;
      this.project.usePurchaseOrder = true;
      this.project.useDocument = true;
      this.project.useAccommodation = true;
      this.project.useTipOfDay = true;
      (this.project.useEntryForCrewTimesheet = true),
        (this.project.useEntryForCrew = true),
        (this.project.useEntryForCrewPo = true),
        (this.project.useEntryForCrewExpenses = true),
        (this.project.useEntryForCrewInvoice = true),
        (this.project.useGreenSupplier = true);
      this.project.useTask = true;
      this.project.hideSalaryInfo = false;
      this.project.hideDealMemoInfo = false;
      this.project.mandatoryExpenseReceipt = false;
      this.project.mandatoryInvoiceReceipt = false;
      this.project.mandatoryCategoryExpense = false;
      this.project.usePlanning = true;
      this.project.useClient = true;
      this.project.useBudget = true;
      this.project.useNightHours = true;
      this.project.useTooEarlyHours = true;
      this.project.useSixthDay = true;
      this.project.useLunchTime = true;
      this.project.useStageDay = true;
      this.project.picture = '';
      this.project.useBeforeCallTime = true;
      this.project.useWeeklyOvt = true;
      this.project.useWeeklyOvt1 = true;
      this.project.useWeeklyOvt2 = true;
      this.project.useSeventhDay = true;
      this.project.useSundayRate = true;
      this.useDinnerPerDiem = true;
      this.useAbroadPerDiem = true;
      this.project.budgetLocked = false;
      this.project.useExpenseTravel = true;
      this.project.useExpenseTicket = true;
      this.project.useExpenseInvoice = true;
      this.project.reference = '';
      this.project.payrollInterface = 0;
      this.project.allowTSEntryOutsideContract = false;
      this.project.allowPOEntryOutsideContract = false;
      this.project.allowExpenseEntryOutsideContract = false;
      this.project.maxExpenseItemsPerSheet = 0;
      this.project.regionalSetting = 0;
      this.project.contractHourlyRatePrecision = DEFAULT_HOUR_RATE_PRECISION;
      this.project.mainProductionCountry = 0;
      this.project.coProductionCountries = null;
      this.project.finalDataAuditDate = null;
      this.project.projectedDataAuditDate = null;
      this.project.hasCncEcoRequirements = false;
    },
    startCapture: function () {
      // initialise global store variable and open dialog to capture and crop
      // console.log("instartcapture");
      store.state.capturedImage = '';
      store.state.imageCropped = '';
      this.disableSaveButton = true;
      this.capturePict = true;
      // console.log("instartcapture store.state.capturedImage", store.state.capturedImage);
    },
    cancelCapture() {
      store.state.capturedImage = '';
      // stop camera
      this.$refs.CaptCompo.onStop();
      this.capturePict = false;
    },
    endCapture: function (item) {
      // stop camera
      this.$refs.CaptCompo.onStop();
      // copy store image name into profile data
      this.capturePict = false;
      // start cropping if image was captured
      if (store.state.capturedImage.length > 0) {
        // an image was captured
        // console.log("in End capture");
        store.state.imageToCrop = store.state.capturedImage;
        this.$refs.myCropPicture.bind(); // force the component to link the new image to the display
        this.cropPict = true;
      }
    },
    endCrop: function (item) {
      // save image to server
      //console.log("this.$refs.myCropPicture.cropped:",this.$refs.myCropPicture.cropped);
      if (store.state.imageCropped.length > 0) {
        this.saveImage(store.state.imageCropped);
      }
      this.cropPict = false;
    },
    endCropCancel: function (item) {
      store.state.imageCropped = '';
      this.cropPict = false;
    },
    b64toFile(b64Data, filename, contentType) {
      const sliceSize = 512;
      const byteCharacters = atob(b64Data);
      let byteArrays = [];
      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        let byteNumbers = new Array(slice.length);

        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      const file = new File(byteArrays, filename, {
        type: contentType
      });
      return file;
    },
    async saveImage(imgData) {
      this.isLoading = true;
      let retStr = '';
      // remove header data:image...
      // const base64Data = imgData.replace(/^data:image\/jpeg;base64,/, '');
      // create in memory file
      // const fil = this.b64toFile(base64Data, 'test.jpg', 'jpg');
      const fil = await reScalingImgWithCanvas(this.img);
      let formData = new FormData(); // instantiate it
      // suppose you have your file ready
      formData.set('uploadimage', fil);
      const config = {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
          'content-type': 'multipart/form-data'
        }
      };
      const urlStr = process.env.VUE_APP_GQL + '/upload';
      axios
        .post(urlStr, formData, config)
        .then((response) => {
          retStr = response.data;
          // console.log("response.data:", retStr);
          this.myProfile.picture = retStr;
          store.state.imageCropped = '';
          // console.log("response.data:", retStr);
          this.updateProjectPictureName();
          this.isLoading = false;
        })
        .catch((error) => {
          // console.log(error);
        })
        .finally(() => (this.isLoading = false));
      return retStr;
    },
    handleImgsTaken(imgs) {
      // console.log('handleImgsTaken', imgs);
      const retStr = imgs[0];
      this.project.picture = retStr;
      // console.log('this.project.picture ', this.project.picture);
      store.state.imageCropped = '';
      this.updateProjectPictureName();
      this.isLoading = false;
      this.refreshTokenCaptureItem = this.refreshTokenCaptureItem + 1;
    },
    updateProjectPictureName() {
      this.saveProject();
    },
    lastNumberValidation(value) {
      return value !== '' && !/^(0[0-9]+)|^(\-[0-9]+)/.test(value);
    },
    decimalNumberValidation(value) {
      const number = parseFloat(value);
      return !isNaN(number) && number >= 0 && number <= 8;
    },
    setLabelFormatValue() {
      const expLengthNumber = /(%0[0-9]+d)$/g;
      const expYearFormat = /\{[Y]+\}/g;

      // offer
      const isDefaultFormatOffer = this.isDefaultFormat(this.project.lastOfferFormat);
      this.selectedRadioOffer = isDefaultFormatOffer;

      if (this.project.lastOfferFormat === '') {
        this.project.lastOfferFormat = this.defaultFormat;
      }

      if (!isDefaultFormatOffer) {
        let format = this.project.lastOfferFormat;
        this.offerInitialLength = this.getLengthFormat(expLengthNumber, format);
        format = format.replace(expLengthNumber, '');
        const matchYearFormat = format.match(expYearFormat) ? format.match(expYearFormat)[0] : '';
        this.selectedRadioOfferYear = keyYearFormat.get(matchYearFormat);
        format = format.replace(matchYearFormat, '');
        this.offerInitialText = format;
      }

      // order
      const isDefaultFormatOrder = this.isDefaultFormat(this.project.lastOrderFormat);
      this.selectedRadioOrder = isDefaultFormatOrder;

      if (this.project.lastOrderFormat === '') {
        this.project.lastOrderFormat = this.defaultFormat;
      }

      if (!isDefaultFormatOrder) {
        let format = this.project.lastOrderFormat;
        this.orderInitialLength = this.getLengthFormat(expLengthNumber, format);
        format = format.replace(expLengthNumber, '');
        const matchYearFormat = format.match(expYearFormat) ? format.match(expYearFormat)[0] : '';
        this.selectedRadioOrderYear = keyYearFormat.get(matchYearFormat);
        format = format.replace(matchYearFormat, '');
        this.orderInitialText = format;
      }

      // invoice
      const isDefaultFormatInvoice = this.isDefaultFormat(this.project.lastInvoiceFormat);
      this.selectedRadioInvoice = isDefaultFormatInvoice;

      if (this.project.lastInvoiceFormat === '') {
        this.project.lastInvoiceFormat = this.defaultFormat;
      }

      if (!isDefaultFormatInvoice) {
        let format = this.project.lastInvoiceFormat;
        this.invoiceInitialLength = this.getLengthFormat(expLengthNumber, format);
        format = format.replace(expLengthNumber, '');
        const matchYearFormat = format.match(expYearFormat) ? format.match(expYearFormat)[0] : '';
        this.selectedRadioInvoiceYear = keyYearFormat.get(matchYearFormat);
        format = format.replace(matchYearFormat, '');
        this.invoiceInitialText = format;
      }

      // purchase order
      const isDefaultFormatPo = this.isDefaultFormat(this.project.lastPoFormat);
      this.selectedRadioPo = isDefaultFormatPo;

      if (this.project.lastPoFormat === '') {
        this.project.lastPoFormat = this.defaultFormat;
      }

      if (!isDefaultFormatPo) {
        let format = this.project.lastPoFormat;
        this.poInitialLength = this.getLengthFormat(expLengthNumber, format);
        format = format.replace(expLengthNumber, '');
        const matchYearFormat = format.match(expYearFormat) ? format.match(expYearFormat)[0] : '';
        this.selectedRadioPoYear = keyYearFormat.get(matchYearFormat);
        format = format.replace(matchYearFormat, '');
        this.poInitialText = format;
      }
    },
    isDefaultFormat(value) {
      return value === this.defaultFormat || value === '';
    },
    getLengthFormat(regExp, value) {
      return parseInt(value.match(regExp)[0].replace(/[%0d]/g, ''), 10);
    },
    getNewFormatValue(project) {
      const offerNumberFormat = `%0${this.offerInitialLength}d`;

      if (this.selectedRadioOffer) {
        this.project.lastOfferFormat = this.defaultFormat;
      } else {
        const yearFormat = valueYearFormat.get(this.selectedRadioOfferYear);
        this.project.lastOfferFormat = this.offerInitialText.toUpperCase() + yearFormat + offerNumberFormat;
      }
      project.lastOfferFormat = this.project.lastOfferFormat;

      const orderNumberFormat = `%0${this.orderInitialLength}d`;

      if (this.selectedRadioOrder) {
        this.project.lastOrderFormat = this.defaultFormat;
      } else {
        const yearFormat = valueYearFormat.get(this.selectedRadioOrderYear);
        this.project.lastOrderFormat = this.orderInitialText.toUpperCase() + yearFormat + orderNumberFormat;
      }
      project.lastOrderFormat = this.project.lastOrderFormat;

      const invoiceNumberFormat = `%0${this.invoiceInitialLength}d`;

      if (this.selectedRadioInvoice) {
        this.project.lastInvoiceFormat = this.defaultFormat;
      } else {
        const yearFormat = valueYearFormat.get(this.selectedRadioInvoiceYear);
        this.project.lastInvoiceFormat = this.invoiceInitialText.toUpperCase() + yearFormat + invoiceNumberFormat;
      }
      project.lastInvoiceFormat = this.project.lastInvoiceFormat;

      const poNumberFormat = `%0${this.poInitialLength}d`;

      if (this.selectedRadioPo) {
        this.project.lastPoFormat = this.defaultFormat;
      } else {
        const yearFormat = valueYearFormat.get(this.selectedRadioPoYear);
        this.project.lastPoFormat = this.poInitialText.toUpperCase() + yearFormat + poNumberFormat;
      }
      project.lastPoFormat = this.project.lastPoFormat;

      project.contractHourlyRatePrecision = +this.project.contractHourlyRatePrecision;

      return project;
    },
    handleChangeOfferParameter() {
      this.getNewFormatValue(this.project);
    },
    handleChangeOrderParameter() {
      this.getNewFormatValue(this.project);
    },
    handleChangeInvoiceParameter() {
      this.getNewFormatValue(this.project);
    },
    handleChangePoParameter() {
      this.getNewFormatValue(this.project);
    },
    handleChangeOfferInitialLength() {
      this.getNewFormatValue(this.project);
    },
    handleChangeOrderInitialLength() {
      this.getNewFormatValue(this.project);
    },
    handleChangeInvoiceInitialLength() {
      this.getNewFormatValue(this.project);
    },
    handleChangePoInitialLength() {
      this.getNewFormatValue(this.project);
    },
    handleChangeOfferYear() {
      this.getNewFormatValue(this.project);
    },
    handleChangeOrderYear() {
      this.getNewFormatValue(this.project);
    },
    handleChangeInvoiceYear() {
      this.getNewFormatValue(this.project);
    },
    handleChangePoYear() {
      this.getNewFormatValue(this.project);
    },
    handleChangeOfferInitialText() {
      this.getNewFormatValue(this.project);
    },
    handleChangeOrderInitialText() {
      this.getNewFormatValue(this.project);
    },
    handleChangeInvoiceInitialText() {
      this.getNewFormatValue(this.project);
    },
    handleChangePoInitialText() {
      this.getNewFormatValue(this.project);
    },
    handleChangeOfferLastNumber() {
      if (this.lastNumberValidation(this.project.lastOfferNumber)) {
        this.getNewFormatValue(this.project);
      }
    },
    handleChangeOrderLastNumber() {
      if (this.lastNumberValidation(this.project.lastOrderNumber)) {
        this.getNewFormatValue(this.project);
      }
    },
    handleChangeInvoiceLastNumber() {
      if (this.lastNumberValidation(this.project.lastInvoiceNumber)) {
        this.getNewFormatValue(this.project);
      }
    },
    handleChangePoLastNumber() {
      if (this.lastNumberValidation(this.project.lastPoNumber)) {
        this.getNewFormatValue(this.project);
      }
    },
    handleChangeContractHourlyRatePrecision() {
      this.getNewFormatValue(this.project);
    },
    async loadCcnForSolo() {
      try {
        const { data } = await apollo.mutate({
          mutation: gql`
            mutation {
              LoadCcnForSolo
            }
          `
        });
        let c = data.LoadCcnForSolo;
        this.createToastForMobile(
          this.FormMSG(252, 'Information'),
          c ? this.FormMSG(253, 'Loading CCN data was successfull') : this.FormMSG(254, 'Loading CCN data faileds'),
          '',
          c ? 'success' : 'danger'
        );
      } catch (e) {
        console.log(e);
      }
    },
    onAdminOwnerUnselected() {
      this.isSupplierUpdate = false;
      this.legalEntities = [];
    },
    handleControlOvertime(payload, type, num) {
      let typeStr = null;

      switch (type) {
        case 'daily':
          typeStr = '';
          break;
        case 'weekly':
          typeStr = 'Weekly';
          break;
      }

      if (num === 1) {
        if (!payload) {
          this.project[`use${typeStr}Ovt${num}`] = false;
          this.project[`use${typeStr}Ovt${num + 1}`] = false;
        }
      } else if (num === 2) {
        if (!payload) {
          this.project[`use${typeStr}Ovt${num}`] = false;
        } else {
          if (type === 'daily') {
            this.project.useOvertime = true;
          } else if (type === 'weekly') {
            this.project.useWeeklyOvt = true;
          }
        }
      } else if (num === 3) {
        if (payload) {
          if (type === 'daily') {
            this.project.useOvertime = true;
          } else if (type === 'weekly') {
            this.project.useWeeklyOvt = true;
          }
          this.project[`use${typeStr}Ovt${num - 2}`] = true;
        }
      }
    },
    handleControlEntryForCrew(payload, num) {
      if (num === 0) {
        this.project.useEntryForCrewExpenses = payload;
        this.project.useEntryForCrewPo = payload;
        this.project.useEntryForCrewTimesheet = payload;
        this.project.useEntryForCrewInvoice = payload;
      } else if (num > 0) {
        if (
          !this.project.useEntryForCrewExpenses &&
          !this.project.useEntryForCrewPo &&
          !this.project.useEntryForCrewTimesheet &&
          !this.project.useEntryForCrewInvoice
        ) {
          this.project.useEntryForCrew = false;
        } else {
          this.project.useEntryForCrew = true;
        }
      }
    },
    handleControlExpense(payload, num) {
      if (num === 0) {
        this.project.useExpenseTravel = payload;
        this.project.useExpenseTicket = payload;
        // this.project.useExpenseInvoice = payload;
      } else if (num > 0) {
        if (!this.project.useExpenseTravel && !this.project.useExpenseTicket /* && !this.project.useExpenseInvoice*/) {
          this.project.useExpense = false;
        } else {
          this.project.useExpense = true;
        }
      }
    },
    handleGreenModel() {
      if (this.project.greenReporting === 3) {
        this.project.carbonModel = 3;
        this.disableCarbonModel = true;
      } else {
        this.project.carbonModel = 7;
        this.disableCarbonModel = true;
      }
    },
    handleControlInvoice(payload, num) {
      if (num === 0) {
        this.project.useExpenseInvoice = payload;
      } else if (num > 0) {
        if (this.project.useFinance === false) this.project.useFinance = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.littleBorderRad {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

.btn {
  margin-bottom: 8px;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.project-picture-preview {
  margin-top: 0.8rem;
  width: 250px;
  height: 250px;
  object-fit: cover;
}

.modal-dialog {
  width: 1000px;
  height: 300px !important;
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  padding: 1.25rem;
  flex: 1 1 auto;
}

// #carbonCalculator {
// 	&.custom-select[disabled=*] {
// 		color: red !important;
// 	}
// 	// #d5d6d7
// }
</style>
